(function() {
  "use strict";
  var n, l$1, u$2, i$1, r$1, o$1, e$1, f$2, c$1, a$1, s$1, h$1, p$1, v$1, d$1 = {}, w$1 = [], _ = /acit|ex(?:s|g|n|p|$)|rph|grid|ows|mnc|ntw|ine[ch]|zoo|^ord|itera/i, g$1 = Array.isArray;
  function m$1(n2, l2) {
    for (var u2 in l2) n2[u2] = l2[u2];
    return n2;
  }
  function b(n2) {
    n2 && n2.parentNode && n2.parentNode.removeChild(n2);
  }
  function k$1(l2, u2, t2) {
    var i2, r2, o2, e2 = {};
    for (o2 in u2) "key" == o2 ? i2 = u2[o2] : "ref" == o2 ? r2 = u2[o2] : e2[o2] = u2[o2];
    if (arguments.length > 2 && (e2.children = arguments.length > 3 ? n.call(arguments, 2) : t2), "function" == typeof l2 && null != l2.defaultProps) for (o2 in l2.defaultProps) void 0 === e2[o2] && (e2[o2] = l2.defaultProps[o2]);
    return x(l2, e2, i2, r2, null);
  }
  function x(n2, t2, i2, r2, o2) {
    var e2 = { type: n2, props: t2, key: i2, ref: r2, __k: null, __: null, __b: 0, __e: null, __c: null, constructor: void 0, __v: null == o2 ? ++u$2 : o2, __i: -1, __u: 0 };
    return null == o2 && null != l$1.vnode && l$1.vnode(e2), e2;
  }
  function S(n2) {
    return n2.children;
  }
  function C$1(n2, l2) {
    this.props = n2, this.context = l2;
  }
  function $(n2, l2) {
    if (null == l2) return n2.__ ? $(n2.__, n2.__i + 1) : null;
    for (var u2; l2 < n2.__k.length; l2++) if (null != (u2 = n2.__k[l2]) && null != u2.__e) return u2.__e;
    return "function" == typeof n2.type ? $(n2) : null;
  }
  function I(n2) {
    if (n2.__P && n2.__d) {
      var u2 = n2.__v, t2 = u2.__e, i2 = [], r2 = [], o2 = m$1({}, u2);
      o2.__v = u2.__v + 1, l$1.vnode && l$1.vnode(o2), q$2(n2.__P, o2, u2, n2.__n, n2.__P.namespaceURI, 32 & u2.__u ? [t2] : null, i2, null == t2 ? $(u2) : t2, !!(32 & u2.__u), r2), o2.__v = u2.__v, o2.__.__k[o2.__i] = o2, D$1(i2, o2, r2), u2.__e = u2.__ = null, o2.__e != t2 && P$1(o2);
    }
  }
  function P$1(n2) {
    if (null != (n2 = n2.__) && null != n2.__c) return n2.__e = n2.__c.base = null, n2.__k.some(function(l2) {
      if (null != l2 && null != l2.__e) return n2.__e = n2.__c.base = l2.__e;
    }), P$1(n2);
  }
  function A$1(n2) {
    (!n2.__d && (n2.__d = true) && i$1.push(n2) && !H$1.__r++ || r$1 != l$1.debounceRendering) && ((r$1 = l$1.debounceRendering) || o$1)(H$1);
  }
  function H$1() {
    try {
      for (var n2, l2 = 1; i$1.length; ) i$1.length > l2 && i$1.sort(e$1), n2 = i$1.shift(), l2 = i$1.length, I(n2);
    } finally {
      i$1.length = H$1.__r = 0;
    }
  }
  function L(n2, l2, u2, t2, i2, r2, o2, e2, f2, c2, a2) {
    var s2, h2, p2, v2, y2, _2, g2, m2 = t2 && t2.__k || w$1, b2 = l2.length;
    for (f2 = T$2(u2, l2, m2, f2, b2), s2 = 0; s2 < b2; s2++) null != (p2 = u2.__k[s2]) && (h2 = -1 != p2.__i && m2[p2.__i] || d$1, p2.__i = s2, _2 = q$2(n2, p2, h2, i2, r2, o2, e2, f2, c2, a2), v2 = p2.__e, p2.ref && h2.ref != p2.ref && (h2.ref && J$1(h2.ref, null, p2), a2.push(p2.ref, p2.__c || v2, p2)), null == y2 && null != v2 && (y2 = v2), (g2 = !!(4 & p2.__u)) || h2.__k === p2.__k ? (f2 = j$2(p2, f2, n2, g2), g2 && h2.__e && (h2.__e = null)) : "function" == typeof p2.type && void 0 !== _2 ? f2 = _2 : v2 && (f2 = v2.nextSibling), p2.__u &= -7);
    return u2.__e = y2, f2;
  }
  function T$2(n2, l2, u2, t2, i2) {
    var r2, o2, e2, f2, c2, a2 = u2.length, s2 = a2, h2 = 0;
    for (n2.__k = new Array(i2), r2 = 0; r2 < i2; r2++) null != (o2 = l2[r2]) && "boolean" != typeof o2 && "function" != typeof o2 ? ("string" == typeof o2 || "number" == typeof o2 || "bigint" == typeof o2 || o2.constructor == String ? o2 = n2.__k[r2] = x(null, o2, null, null, null) : g$1(o2) ? o2 = n2.__k[r2] = x(S, { children: o2 }, null, null, null) : void 0 === o2.constructor && o2.__b > 0 ? o2 = n2.__k[r2] = x(o2.type, o2.props, o2.key, o2.ref ? o2.ref : null, o2.__v) : n2.__k[r2] = o2, f2 = r2 + h2, o2.__ = n2, o2.__b = n2.__b + 1, e2 = null, -1 != (c2 = o2.__i = O$1(o2, u2, f2, s2)) && (s2--, (e2 = u2[c2]) && (e2.__u |= 2)), null == e2 || null == e2.__v ? (-1 == c2 && (i2 > a2 ? h2-- : i2 < a2 && h2++), "function" != typeof o2.type && (o2.__u |= 4)) : c2 != f2 && (c2 == f2 - 1 ? h2-- : c2 == f2 + 1 ? h2++ : (c2 > f2 ? h2-- : h2++, o2.__u |= 4))) : n2.__k[r2] = null;
    if (s2) for (r2 = 0; r2 < a2; r2++) null != (e2 = u2[r2]) && 0 == (2 & e2.__u) && (e2.__e == t2 && (t2 = $(e2)), K$1(e2, e2));
    return t2;
  }
  function j$2(n2, l2, u2, t2) {
    var i2, r2;
    if ("function" == typeof n2.type) {
      for (i2 = n2.__k, r2 = 0; i2 && r2 < i2.length; r2++) i2[r2] && (i2[r2].__ = n2, l2 = j$2(i2[r2], l2, u2, t2));
      return l2;
    }
    n2.__e != l2 && (t2 && (l2 && n2.type && !l2.parentNode && (l2 = $(n2)), u2.insertBefore(n2.__e, l2 || null)), l2 = n2.__e);
    do {
      l2 = l2 && l2.nextSibling;
    } while (null != l2 && 8 == l2.nodeType);
    return l2;
  }
  function F(n2, l2) {
    return l2 = l2 || [], null == n2 || "boolean" == typeof n2 || (g$1(n2) ? n2.some(function(n3) {
      F(n3, l2);
    }) : l2.push(n2)), l2;
  }
  function O$1(n2, l2, u2, t2) {
    var i2, r2, o2, e2 = n2.key, f2 = n2.type, c2 = l2[u2], a2 = null != c2 && 0 == (2 & c2.__u);
    if (null === c2 && null == e2 || a2 && e2 == c2.key && f2 == c2.type) return u2;
    if (t2 > (a2 ? 1 : 0)) {
      for (i2 = u2 - 1, r2 = u2 + 1; i2 >= 0 || r2 < l2.length; ) if (null != (c2 = l2[o2 = i2 >= 0 ? i2-- : r2++]) && 0 == (2 & c2.__u) && e2 == c2.key && f2 == c2.type) return o2;
    }
    return -1;
  }
  function z$1(n2, l2, u2) {
    "-" == l2[0] ? n2.setProperty(l2, null == u2 ? "" : u2) : n2[l2] = null == u2 ? "" : "number" != typeof u2 || _.test(l2) ? u2 : u2 + "px";
  }
  function N(n2, l2, u2, t2, i2) {
    var r2, o2;
    n: if ("style" == l2) if ("string" == typeof u2) n2.style.cssText = u2;
    else {
      if ("string" == typeof t2 && (n2.style.cssText = t2 = ""), t2) for (l2 in t2) u2 && l2 in u2 || z$1(n2.style, l2, "");
      if (u2) for (l2 in u2) t2 && u2[l2] == t2[l2] || z$1(n2.style, l2, u2[l2]);
    }
    else if ("o" == l2[0] && "n" == l2[1]) r2 = l2 != (l2 = l2.replace(s$1, "$1")), o2 = l2.toLowerCase(), l2 = o2 in n2 || "onFocusOut" == l2 || "onFocusIn" == l2 ? o2.slice(2) : l2.slice(2), n2.l || (n2.l = {}), n2.l[l2 + r2] = u2, u2 ? t2 ? u2[a$1] = t2[a$1] : (u2[a$1] = h$1, n2.addEventListener(l2, r2 ? v$1 : p$1, r2)) : n2.removeEventListener(l2, r2 ? v$1 : p$1, r2);
    else {
      if ("http://www.w3.org/2000/svg" == i2) l2 = l2.replace(/xlink(H|:h)/, "h").replace(/sName$/, "s");
      else if ("width" != l2 && "height" != l2 && "href" != l2 && "list" != l2 && "form" != l2 && "tabIndex" != l2 && "download" != l2 && "rowSpan" != l2 && "colSpan" != l2 && "role" != l2 && "popover" != l2 && l2 in n2) try {
        n2[l2] = null == u2 ? "" : u2;
        break n;
      } catch (n3) {
      }
      "function" == typeof u2 || (null == u2 || false === u2 && "-" != l2[4] ? n2.removeAttribute(l2) : n2.setAttribute(l2, "popover" == l2 && 1 == u2 ? "" : u2));
    }
  }
  function V$1(n2) {
    return function(u2) {
      if (this.l) {
        var t2 = this.l[u2.type + n2];
        if (null == u2[c$1]) u2[c$1] = h$1++;
        else if (u2[c$1] < t2[a$1]) return;
        return t2(l$1.event ? l$1.event(u2) : u2);
      }
    };
  }
  function q$2(n2, u2, t2, i2, r2, o2, e2, f2, c2, a2) {
    var s2, h2, p2, v2, y2, d2, _2, k2, x2, M2, $2, I2, P2, A2, H2, T2 = u2.type;
    if (void 0 !== u2.constructor) return null;
    128 & t2.__u && (c2 = !!(32 & t2.__u), o2 = [f2 = u2.__e = t2.__e]), (s2 = l$1.__b) && s2(u2);
    n: if ("function" == typeof T2) try {
      if (k2 = u2.props, x2 = T2.prototype && T2.prototype.render, M2 = (s2 = T2.contextType) && i2[s2.__c], $2 = s2 ? M2 ? M2.props.value : s2.__ : i2, t2.__c ? _2 = (h2 = u2.__c = t2.__c).__ = h2.__E : (x2 ? u2.__c = h2 = new T2(k2, $2) : (u2.__c = h2 = new C$1(k2, $2), h2.constructor = T2, h2.render = Q$1), M2 && M2.sub(h2), h2.state || (h2.state = {}), h2.__n = i2, p2 = h2.__d = true, h2.__h = [], h2._sb = []), x2 && null == h2.__s && (h2.__s = h2.state), x2 && null != T2.getDerivedStateFromProps && (h2.__s == h2.state && (h2.__s = m$1({}, h2.__s)), m$1(h2.__s, T2.getDerivedStateFromProps(k2, h2.__s))), v2 = h2.props, y2 = h2.state, h2.__v = u2, p2) x2 && null == T2.getDerivedStateFromProps && null != h2.componentWillMount && h2.componentWillMount(), x2 && null != h2.componentDidMount && h2.__h.push(h2.componentDidMount);
      else {
        if (x2 && null == T2.getDerivedStateFromProps && k2 !== v2 && null != h2.componentWillReceiveProps && h2.componentWillReceiveProps(k2, $2), u2.__v == t2.__v || !h2.__e && null != h2.shouldComponentUpdate && false === h2.shouldComponentUpdate(k2, h2.__s, $2)) {
          u2.__v != t2.__v && (h2.props = k2, h2.state = h2.__s, h2.__d = false), u2.__e = t2.__e, u2.__k = t2.__k, u2.__k.some(function(n3) {
            n3 && (n3.__ = u2);
          }), w$1.push.apply(h2.__h, h2._sb), h2._sb = [], h2.__h.length && e2.push(h2);
          break n;
        }
        null != h2.componentWillUpdate && h2.componentWillUpdate(k2, h2.__s, $2), x2 && null != h2.componentDidUpdate && h2.__h.push(function() {
          h2.componentDidUpdate(v2, y2, d2);
        });
      }
      if (h2.context = $2, h2.props = k2, h2.__P = n2, h2.__e = false, I2 = l$1.__r, P2 = 0, x2) h2.state = h2.__s, h2.__d = false, I2 && I2(u2), s2 = h2.render(h2.props, h2.state, h2.context), w$1.push.apply(h2.__h, h2._sb), h2._sb = [];
      else do {
        h2.__d = false, I2 && I2(u2), s2 = h2.render(h2.props, h2.state, h2.context), h2.state = h2.__s;
      } while (h2.__d && ++P2 < 25);
      h2.state = h2.__s, null != h2.getChildContext && (i2 = m$1(m$1({}, i2), h2.getChildContext())), x2 && !p2 && null != h2.getSnapshotBeforeUpdate && (d2 = h2.getSnapshotBeforeUpdate(v2, y2)), A2 = null != s2 && s2.type === S && null == s2.key ? E$1(s2.props.children) : s2, f2 = L(n2, g$1(A2) ? A2 : [A2], u2, t2, i2, r2, o2, e2, f2, c2, a2), h2.base = u2.__e, u2.__u &= -161, h2.__h.length && e2.push(h2), _2 && (h2.__E = h2.__ = null);
    } catch (n3) {
      if (u2.__v = null, c2 || null != o2) if (n3.then) {
        for (u2.__u |= c2 ? 160 : 128; f2 && 8 == f2.nodeType && f2.nextSibling; ) f2 = f2.nextSibling;
        o2[o2.indexOf(f2)] = null, u2.__e = f2;
      } else {
        for (H2 = o2.length; H2--; ) b(o2[H2]);
        B$2(u2);
      }
      else u2.__e = t2.__e, u2.__k = t2.__k, n3.then || B$2(u2);
      l$1.__e(n3, u2, t2);
    }
    else null == o2 && u2.__v == t2.__v ? (u2.__k = t2.__k, u2.__e = t2.__e) : f2 = u2.__e = G$1(t2.__e, u2, t2, i2, r2, o2, e2, c2, a2);
    return (s2 = l$1.diffed) && s2(u2), 128 & u2.__u ? void 0 : f2;
  }
  function B$2(n2) {
    n2 && (n2.__c && (n2.__c.__e = true), n2.__k && n2.__k.some(B$2));
  }
  function D$1(n2, u2, t2) {
    for (var i2 = 0; i2 < t2.length; i2++) J$1(t2[i2], t2[++i2], t2[++i2]);
    l$1.__c && l$1.__c(u2, n2), n2.some(function(u3) {
      try {
        n2 = u3.__h, u3.__h = [], n2.some(function(n3) {
          n3.call(u3);
        });
      } catch (n3) {
        l$1.__e(n3, u3.__v);
      }
    });
  }
  function E$1(n2) {
    return "object" != typeof n2 || null == n2 || n2.__b > 0 ? n2 : g$1(n2) ? n2.map(E$1) : void 0 !== n2.constructor ? null : m$1({}, n2);
  }
  function G$1(u2, t2, i2, r2, o2, e2, f2, c2, a2) {
    var s2, h2, p2, v2, y2, w2, _2, m2 = i2.props || d$1, k2 = t2.props, x2 = t2.type;
    if ("svg" == x2 ? o2 = "http://www.w3.org/2000/svg" : "math" == x2 ? o2 = "http://www.w3.org/1998/Math/MathML" : o2 || (o2 = "http://www.w3.org/1999/xhtml"), null != e2) {
      for (s2 = 0; s2 < e2.length; s2++) if ((y2 = e2[s2]) && "setAttribute" in y2 == !!x2 && (x2 ? y2.localName == x2 : 3 == y2.nodeType)) {
        u2 = y2, e2[s2] = null;
        break;
      }
    }
    if (null == u2) {
      if (null == x2) return document.createTextNode(k2);
      u2 = document.createElementNS(o2, x2, k2.is && k2), c2 && (l$1.__m && l$1.__m(t2, e2), c2 = false), e2 = null;
    }
    if (null == x2) m2 === k2 || c2 && u2.data == k2 || (u2.data = k2);
    else {
      if (e2 = "textarea" == x2 && null != k2.defaultValue ? null : e2 && n.call(u2.childNodes), !c2 && null != e2) for (m2 = {}, s2 = 0; s2 < u2.attributes.length; s2++) m2[(y2 = u2.attributes[s2]).name] = y2.value;
      for (s2 in m2) y2 = m2[s2], "dangerouslySetInnerHTML" == s2 ? p2 = y2 : "children" == s2 || s2 in k2 || "value" == s2 && "defaultValue" in k2 || "checked" == s2 && "defaultChecked" in k2 || N(u2, s2, null, y2, o2);
      for (s2 in k2) y2 = k2[s2], "children" == s2 ? v2 = y2 : "dangerouslySetInnerHTML" == s2 ? h2 = y2 : "value" == s2 ? w2 = y2 : "checked" == s2 ? _2 = y2 : c2 && "function" != typeof y2 || m2[s2] === y2 || N(u2, s2, y2, m2[s2], o2);
      if (h2) c2 || p2 && (h2.__html == p2.__html || h2.__html == u2.innerHTML) || (u2.innerHTML = h2.__html), t2.__k = [];
      else if (p2 && (u2.innerHTML = ""), L("template" == t2.type ? u2.content : u2, g$1(v2) ? v2 : [v2], t2, i2, r2, "foreignObject" == x2 ? "http://www.w3.org/1999/xhtml" : o2, e2, f2, e2 ? e2[0] : i2.__k && $(i2, 0), c2, a2), null != e2) for (s2 = e2.length; s2--; ) b(e2[s2]);
      c2 && "textarea" != x2 || (s2 = "value", "progress" == x2 && null == w2 ? u2.removeAttribute("value") : null != w2 && (w2 !== u2[s2] || "progress" == x2 && !w2 || "option" == x2 && w2 != m2[s2]) && N(u2, s2, w2, m2[s2], o2), s2 = "checked", null != _2 && _2 != u2[s2] && N(u2, s2, _2, m2[s2], o2));
    }
    return u2;
  }
  function J$1(n2, u2, t2) {
    try {
      if ("function" == typeof n2) {
        var i2 = "function" == typeof n2.__u;
        i2 && n2.__u(), i2 && null == u2 || (n2.__u = n2(u2));
      } else n2.current = u2;
    } catch (n3) {
      l$1.__e(n3, t2);
    }
  }
  function K$1(n2, u2, t2) {
    var i2, r2;
    if (l$1.unmount && l$1.unmount(n2), (i2 = n2.ref) && (i2.current && i2.current != n2.__e || J$1(i2, null, u2)), null != (i2 = n2.__c)) {
      if (i2.componentWillUnmount) try {
        i2.componentWillUnmount();
      } catch (n3) {
        l$1.__e(n3, u2);
      }
      i2.base = i2.__P = null;
    }
    if (i2 = n2.__k) for (r2 = 0; r2 < i2.length; r2++) i2[r2] && K$1(i2[r2], u2, t2 || "function" != typeof n2.type);
    t2 || b(n2.__e), n2.__c = n2.__ = n2.__e = void 0;
  }
  function Q$1(n2, l2, u2) {
    return this.constructor(n2, u2);
  }
  function R(u2, t2, i2) {
    var r2, o2, e2, f2;
    t2 == document && (t2 = document.documentElement), l$1.__ && l$1.__(u2, t2), o2 = (r2 = false) ? null : t2.__k, e2 = [], f2 = [], q$2(t2, u2 = t2.__k = k$1(S, null, [u2]), o2 || d$1, d$1, t2.namespaceURI, o2 ? null : t2.firstChild ? n.call(t2.childNodes) : null, e2, o2 ? o2.__e : t2.firstChild, r2, f2), D$1(e2, u2, f2);
  }
  n = w$1.slice, l$1 = { __e: function(n2, l2, u2, t2) {
    for (var i2, r2, o2; l2 = l2.__; ) if ((i2 = l2.__c) && !i2.__) try {
      if ((r2 = i2.constructor) && null != r2.getDerivedStateFromError && (i2.setState(r2.getDerivedStateFromError(n2)), o2 = i2.__d), null != i2.componentDidCatch && (i2.componentDidCatch(n2, t2 || {}), o2 = i2.__d), o2) return i2.__E = i2;
    } catch (l3) {
      n2 = l3;
    }
    throw n2;
  } }, u$2 = 0, C$1.prototype.setState = function(n2, l2) {
    var u2;
    u2 = null != this.__s && this.__s != this.state ? this.__s : this.__s = m$1({}, this.state), "function" == typeof n2 && (n2 = n2(m$1({}, u2), this.props)), n2 && m$1(u2, n2), null != n2 && this.__v && (l2 && this._sb.push(l2), A$1(this));
  }, C$1.prototype.forceUpdate = function(n2) {
    this.__v && (this.__e = true, n2 && this.__h.push(n2), A$1(this));
  }, C$1.prototype.render = S, i$1 = [], o$1 = "function" == typeof Promise ? Promise.prototype.then.bind(Promise.resolve()) : setTimeout, e$1 = function(n2, l2) {
    return n2.__v.__b - l2.__v.__b;
  }, H$1.__r = 0, f$2 = Math.random().toString(8), c$1 = "__d" + f$2, a$1 = "__a" + f$2, s$1 = /(PointerCapture)$|Capture$/i, h$1 = 0, p$1 = V$1(false), v$1 = V$1(true);
  var f$1 = 0;
  function u$1(e2, t2, n2, o2, i2, u2) {
    t2 || (t2 = {});
    var a2, c2, p2 = t2;
    if ("ref" in p2) for (c2 in p2 = {}, t2) "ref" == c2 ? a2 = t2[c2] : p2[c2] = t2[c2];
    var l2 = { type: e2, props: p2, key: n2, ref: a2, __k: null, __: null, __b: 0, __e: null, __c: null, constructor: void 0, __v: --f$1, __i: -1, __u: 0, __source: i2, __self: u2 };
    if ("function" == typeof e2 && (a2 = e2.defaultProps)) for (c2 in a2) void 0 === p2[c2] && (p2[c2] = a2[c2]);
    return l$1.vnode && l$1.vnode(l2), l2;
  }
  var t, r, u, i, o = 0, f = [], c = l$1, e = c.__b, a = c.__r, v = c.diffed, l = c.__c, m = c.unmount, s = c.__;
  function p(n2, t2) {
    c.__h && c.__h(r, n2, o || t2), o = 0;
    var u2 = r.__H || (r.__H = { __: [], __h: [] });
    return n2 >= u2.__.length && u2.__.push({}), u2.__[n2];
  }
  function d(n2) {
    return o = 1, h(D, n2);
  }
  function h(n2, u2, i2) {
    var o2 = p(t++, 2);
    if (o2.t = n2, !o2.__c && (o2.__ = [i2 ? i2(u2) : D(void 0, u2), function(n3) {
      var t2 = o2.__N ? o2.__N[0] : o2.__[0], r2 = o2.t(t2, n3);
      t2 !== r2 && (o2.__N = [r2, o2.__[1]], o2.__c.setState({}));
    }], o2.__c = r, !r.__f)) {
      var f2 = function(n3, t2, r2) {
        if (!o2.__c.__H) return true;
        var u3 = o2.__c.__H.__.filter(function(n4) {
          return n4.__c;
        });
        if (u3.every(function(n4) {
          return !n4.__N;
        })) return !c2 || c2.call(this, n3, t2, r2);
        var i3 = o2.__c.props !== n3;
        return u3.some(function(n4) {
          if (n4.__N) {
            var t3 = n4.__[0];
            n4.__ = n4.__N, n4.__N = void 0, t3 !== n4.__[0] && (i3 = true);
          }
        }), c2 && c2.call(this, n3, t2, r2) || i3;
      };
      r.__f = true;
      var c2 = r.shouldComponentUpdate, e2 = r.componentWillUpdate;
      r.componentWillUpdate = function(n3, t2, r2) {
        if (this.__e) {
          var u3 = c2;
          c2 = void 0, f2(n3, t2, r2), c2 = u3;
        }
        e2 && e2.call(this, n3, t2, r2);
      }, r.shouldComponentUpdate = f2;
    }
    return o2.__N || o2.__;
  }
  function y(n2, u2) {
    var i2 = p(t++, 3);
    !c.__s && C(i2.__H, u2) && (i2.__ = n2, i2.u = u2, r.__H.__h.push(i2));
  }
  function A(n2) {
    return o = 5, T$1(function() {
      return { current: n2 };
    }, []);
  }
  function T$1(n2, r2) {
    var u2 = p(t++, 7);
    return C(u2.__H, r2) && (u2.__ = n2(), u2.__H = r2, u2.__h = n2), u2.__;
  }
  function q$1(n2, t2) {
    return o = 8, T$1(function() {
      return n2;
    }, t2);
  }
  function j$1() {
    for (var n2; n2 = f.shift(); ) {
      var t2 = n2.__H;
      if (n2.__P && t2) try {
        t2.__h.some(z), t2.__h.some(B$1), t2.__h = [];
      } catch (r2) {
        t2.__h = [], c.__e(r2, n2.__v);
      }
    }
  }
  c.__b = function(n2) {
    r = null, e && e(n2);
  }, c.__ = function(n2, t2) {
    n2 && t2.__k && t2.__k.__m && (n2.__m = t2.__k.__m), s && s(n2, t2);
  }, c.__r = function(n2) {
    a && a(n2), t = 0;
    var i2 = (r = n2.__c).__H;
    i2 && (u === r ? (i2.__h = [], r.__h = [], i2.__.some(function(n3) {
      n3.__N && (n3.__ = n3.__N), n3.u = n3.__N = void 0;
    })) : (i2.__h.some(z), i2.__h.some(B$1), i2.__h = [], t = 0)), u = r;
  }, c.diffed = function(n2) {
    v && v(n2);
    var t2 = n2.__c;
    t2 && t2.__H && (t2.__H.__h.length && (1 !== f.push(t2) && i === c.requestAnimationFrame || ((i = c.requestAnimationFrame) || w)(j$1)), t2.__H.__.some(function(n3) {
      n3.u && (n3.__H = n3.u), n3.u = void 0;
    })), u = r = null;
  }, c.__c = function(n2, t2) {
    t2.some(function(n3) {
      try {
        n3.__h.some(z), n3.__h = n3.__h.filter(function(n4) {
          return !n4.__ || B$1(n4);
        });
      } catch (r2) {
        t2.some(function(n4) {
          n4.__h && (n4.__h = []);
        }), t2 = [], c.__e(r2, n3.__v);
      }
    }), l && l(n2, t2);
  }, c.unmount = function(n2) {
    m && m(n2);
    var t2, r2 = n2.__c;
    r2 && r2.__H && (r2.__H.__.some(function(n3) {
      try {
        z(n3);
      } catch (n4) {
        t2 = n4;
      }
    }), r2.__H = void 0, t2 && c.__e(t2, r2.__v));
  };
  var k = "function" == typeof requestAnimationFrame;
  function w(n2) {
    var t2, r2 = function() {
      clearTimeout(u2), k && cancelAnimationFrame(t2), setTimeout(n2);
    }, u2 = setTimeout(r2, 35);
    k && (t2 = requestAnimationFrame(r2));
  }
  function z(n2) {
    var t2 = r, u2 = n2.__c;
    "function" == typeof u2 && (n2.__c = void 0, u2()), r = t2;
  }
  function B$1(n2) {
    var t2 = r;
    n2.__c = n2.__(), r = t2;
  }
  function C(n2, t2) {
    return !n2 || n2.length !== t2.length || t2.some(function(t3, r2) {
      return t3 !== n2[r2];
    });
  }
  function D(n2, t2) {
    return "function" == typeof t2 ? t2(n2) : t2;
  }
  function TorusBundleHero() {
    const badges = [
      "Matched to your pet's routine",
      "Filter coverage included",
      "Choose your color",
      "Useful add-ons only"
    ];
    return /* @__PURE__ */ u$1("section", { className: "torus-hero", "aria-labelledby": "torus-hero-heading", children: [
      /* @__PURE__ */ u$1("div", { className: "torus-hero__copy", children: [
        /* @__PURE__ */ u$1("h1", { id: "torus-hero-heading", className: "torus-hero__title", children: "Fresh water starts with the right setup." }),
        /* @__PURE__ */ u$1("p", { className: "torus-hero__subtitle", children: "Build a complete Torus hydration setup for your pet — dispenser, filters, and useful extras matched to how they drink every day." }),
        /* @__PURE__ */ u$1("ul", { className: "torus-hero__badges", "aria-label": "Setup highlights", children: badges.map((badge) => /* @__PURE__ */ u$1("li", { className: "torus-hero__badge", children: badge }, badge)) })
      ] }),
      /* @__PURE__ */ u$1("div", { className: "torus-hero__stack", "aria-hidden": "true", children: [
        /* @__PURE__ */ u$1("div", { className: "torus-hero__card torus-hero__card--dispenser", children: [
          /* @__PURE__ */ u$1("span", { className: "torus-hero__icon", role: "img", "aria-label": "", children: /* @__PURE__ */ u$1("img", { className: "torus_dispenser", src: "https://toruspetglobal.com/cdn/shop/files/Copy_of_Untitled_Design.gif", alt: "Torus Dispenser" }) }),
          /* @__PURE__ */ u$1("h2", { className: "torus-hero__card-title", children: "Torus dispenser" }),
          /* @__PURE__ */ u$1("p", { className: "torus-hero__card-text", children: "Fresh water base" })
        ] }),
        /* @__PURE__ */ u$1("span", { className: "torus-hero__plus", children: "+" }),
        /* @__PURE__ */ u$1("div", { className: "torus-hero__card_right", children: [
          /* @__PURE__ */ u$1("div", { className: "torus-hero__card torus-hero__card--filters", children: [
            /* @__PURE__ */ u$1("span", { className: "torus-hero__icon", role: "img", "aria-label": "", children: /* @__PURE__ */ u$1("img", { className: "torus_filter", src: "https://toruspetglobal.com/cdn/shop/files/Advanced_Filter_a4c7e382-048c-4162-9c15-a8b54bd18be3.png", alt: "Torus Filter" }) }),
            /* @__PURE__ */ u$1("h2", { className: "torus-hero__card-title", children: "Filters" }),
            /* @__PURE__ */ u$1("p", { className: "torus-hero__card-text", children: "Coverage included" })
          ] }),
          /* @__PURE__ */ u$1("div", { className: "torus-hero__card torus-hero__card--extras", children: [
            /* @__PURE__ */ u$1("span", { className: "torus-hero__icon", role: "img", "aria-label": "", children: /* @__PURE__ */ u$1("img", { className: "torus_tote_bag", src: "https://toruspetglobal.com/cdn/shop/files/torus_OPLAUG25__16470_V2copy.png", alt: "Torus Tote Bag" }) }),
            /* @__PURE__ */ u$1("h2", { className: "torus-hero__card-title", children: "Lifestyle extras" }),
            /* @__PURE__ */ u$1("p", { className: "torus-hero__card-text", children: "Travel & spares" })
          ] })
        ] })
      ] })
    ] });
  }
  function TorusPetSelector({ data, onSelect, handleSelectedOption }) {
    var _a;
    const [loadedImages, setLoadedImages] = d({});
    const setupOptions = ((_a = data == null ? void 0 : data.bundleBuilder) == null ? void 0 : _a.setupOptions) || [];
    const isDataReady = setupOptions.length > 0;
    let primarySelectionOption = isDataReady ? setupOptions.slice(0, 6) : Array.from({ length: 6 }, (_2, index) => ({ id: `skeleton-card-${index}` }));
    let secondarySelectionOption = isDataReady ? setupOptions.slice(6) : Array.from({ length: 2 }, (_2, index) => ({ id: `skeleton-action-${index}` }));
    const handleImageLoad = (id) => {
      setLoadedImages((prev) => ({ ...prev, [id]: true }));
    };
    const handleSelect = (id) => {
      console.log("id ", id);
      const matchedKey = Object.keys(data.bundleBuilder.setups).find((key) => key === id);
      const matchedData = matchedKey ? data.bundleBuilder.setups[matchedKey] : null;
      window.activeSetUp = matchedData;
      handleSelectedOption(matchedData);
      const url = new URL(window.location.href);
      url.searchParams.set("type", id);
      window.history.pushState({}, "", url);
      if (onSelect) onSelect(id);
    };
    const handleKeyDown = (event, id) => {
      if (event.key === "Enter" || event.key === " ") {
        event.preventDefault();
        handleSelect(id);
      }
    };
    return /* @__PURE__ */ u$1("section", { className: "torus-selector", "aria-labelledby": "torus-selector-heading", children: [
      /* @__PURE__ */ u$1("div", { className: "torus-selector__header_container", children: [
        /* @__PURE__ */ u$1("div", { className: "torus-selector__header", children: [
          /* @__PURE__ */ u$1("h2", { id: "torus-selector-heading", className: "torus-selector__title", children: "Who are you hydrating today?" }),
          /* @__PURE__ */ u$1("a", { href: "#how-it-works", className: "torus-selector__link", children: "Not sure what to choose? See how your setup is built" })
        ] }),
        /* @__PURE__ */ u$1("button", { type: "button", className: "torus-selector__quick-setup", children: "Quick setup" })
      ] }),
      /* @__PURE__ */ u$1("ul", { className: "torus-selector__grid", role: "list", children: primarySelectionOption.map((profile) => {
        const imageLoaded = isDataReady && loadedImages[profile.id];
        return /* @__PURE__ */ u$1("li", { children: /* @__PURE__ */ u$1(
          "button",
          {
            type: "button",
            className: "torus-selector__card",
            id: profile.id,
            disabled: !isDataReady,
            onClick: () => handleSelect(profile.id),
            onKeyDown: (event) => handleKeyDown(event, profile.id),
            "aria-label": isDataReady ? `${profile.title}: ${profile.description}` : "Loading",
            children: [
              /* @__PURE__ */ u$1("span", { className: "torus-selector__icon", role: "img", "aria-hidden": "true", children: [
                !imageLoaded && /* @__PURE__ */ u$1("span", { className: "torus-selector__skeleton torus-selector__skeleton--icon" }),
                isDataReady && /* @__PURE__ */ u$1(
                  "img",
                  {
                    src: profile.bundleImage.src,
                    alt: profile.bundleImage.alt,
                    style: { display: imageLoaded ? "block" : "none" },
                    onLoad: () => handleImageLoad(profile.id)
                  }
                )
              ] }),
              imageLoaded ? /* @__PURE__ */ u$1(S, { children: [
                /* @__PURE__ */ u$1("span", { className: "torus-selector__card-title", children: profile.title }),
                /* @__PURE__ */ u$1("span", { className: "torus-selector__card-text", children: profile.description })
              ] }) : /* @__PURE__ */ u$1(S, { children: [
                /* @__PURE__ */ u$1("span", { className: "torus-selector__skeleton torus-selector__skeleton--title" }),
                /* @__PURE__ */ u$1("span", { className: "torus-selector__skeleton torus-selector__skeleton--text" })
              ] })
            ]
          }
        ) }, profile.id);
      }) }),
      /* @__PURE__ */ u$1("div", { className: "torus-selector__actions", children: secondarySelectionOption.map((option) => /* @__PURE__ */ u$1(
        "button",
        {
          type: "button",
          className: "torus-selector__action torus-selector__action--build",
          onClick: () => handleSelect(option.id),
          id: option.id,
          disabled: !isDataReady,
          children: isDataReady ? /* @__PURE__ */ u$1(S, { children: [
            /* @__PURE__ */ u$1("span", { className: "torus-selector__action-title", children: option.title }),
            /* @__PURE__ */ u$1("span", { className: "torus-selector__action-text", children: option.description })
          ] }) : /* @__PURE__ */ u$1(S, { children: [
            /* @__PURE__ */ u$1("span", { className: "torus-selector__skeleton torus-selector__skeleton--action-title" }),
            /* @__PURE__ */ u$1("span", { className: "torus-selector__skeleton torus-selector__skeleton--action-text" })
          ] })
        }
      )) })
    ] });
  }
  function g(n2, t2) {
    for (var e2 in t2) n2[e2] = t2[e2];
    return n2;
  }
  function E(n2, t2) {
    for (var e2 in n2) if ("__source" !== e2 && !(e2 in t2)) return true;
    for (var r2 in t2) if ("__source" !== r2 && n2[r2] !== t2[r2]) return true;
    return false;
  }
  function M(n2, t2) {
    this.props = n2, this.context = t2;
  }
  (M.prototype = new C$1()).isPureReactComponent = true, M.prototype.shouldComponentUpdate = function(n2, t2) {
    return E(this.props, n2) || E(this.state, t2);
  };
  var T = l$1.__b;
  l$1.__b = function(n2) {
    n2.type && n2.type.__f && n2.ref && (n2.props.ref = n2.ref, n2.ref = null), T && T(n2);
  };
  var O = l$1.__e;
  l$1.__e = function(n2, t2, e2, r2) {
    if (n2.then) {
      for (var u2, o2 = t2; o2 = o2.__; ) if ((u2 = o2.__c) && u2.__c) return null == t2.__e && (t2.__e = e2.__e, t2.__k = e2.__k), u2.__c(n2, t2);
    }
    O(n2, t2, e2, r2);
  };
  var U = l$1.unmount;
  function V(n2, t2, e2) {
    return n2 && (n2.__c && n2.__c.__H && (n2.__c.__H.__.forEach(function(n3) {
      "function" == typeof n3.__c && n3.__c();
    }), n2.__c.__H = null), null != (n2 = g({}, n2)).__c && (n2.__c.__P === e2 && (n2.__c.__P = t2), n2.__c.__e = true, n2.__c = null), n2.__k = n2.__k && n2.__k.map(function(n3) {
      return V(n3, t2, e2);
    })), n2;
  }
  function W(n2, t2, e2) {
    return n2 && e2 && (n2.__v = null, n2.__k = n2.__k && n2.__k.map(function(n3) {
      return W(n3, t2, e2);
    }), n2.__c && n2.__c.__P === t2 && (n2.__e && e2.appendChild(n2.__e), n2.__c.__e = true, n2.__c.__P = e2)), n2;
  }
  function P() {
    this.__u = 0, this.o = null, this.__b = null;
  }
  function j(n2) {
    var t2 = n2.__ && n2.__.__c;
    return t2 && t2.__a && t2.__a(n2);
  }
  function B() {
    this.i = null, this.l = null;
  }
  l$1.unmount = function(n2) {
    var t2 = n2.__c;
    t2 && (t2.__z = true), t2 && t2.__R && t2.__R(), t2 && 32 & n2.__u && (n2.type = null), U && U(n2);
  }, (P.prototype = new C$1()).__c = function(n2, t2) {
    var e2 = t2.__c, r2 = this;
    null == r2.o && (r2.o = []), r2.o.push(e2);
    var u2 = j(r2.__v), o2 = false, i2 = function() {
      o2 || r2.__z || (o2 = true, e2.__R = null, u2 ? u2(c2) : c2());
    };
    e2.__R = i2;
    var l2 = e2.__P;
    e2.__P = null;
    var c2 = function() {
      if (!--r2.__u) {
        if (r2.state.__a) {
          var n3 = r2.state.__a;
          r2.__v.__k[0] = W(n3, n3.__c.__P, n3.__c.__O);
        }
        var t3;
        for (r2.setState({ __a: r2.__b = null }); t3 = r2.o.pop(); ) t3.__P = l2, t3.forceUpdate();
      }
    };
    r2.__u++ || 32 & t2.__u || r2.setState({ __a: r2.__b = r2.__v.__k[0] }), n2.then(i2, i2);
  }, P.prototype.componentWillUnmount = function() {
    this.o = [];
  }, P.prototype.render = function(n2, e2) {
    if (this.__b) {
      if (this.__v.__k) {
        var r2 = document.createElement("div"), o2 = this.__v.__k[0].__c;
        this.__v.__k[0] = V(this.__b, r2, o2.__O = o2.__P);
      }
      this.__b = null;
    }
    var i2 = e2.__a && k$1(S, null, n2.fallback);
    return i2 && (i2.__u &= -33), [k$1(S, null, e2.__a ? null : n2.children), i2];
  };
  var H = function(n2, t2, e2) {
    if (++e2[1] === e2[0] && n2.l.delete(t2), n2.props.revealOrder && ("t" !== n2.props.revealOrder[0] || !n2.l.size)) for (e2 = n2.i; e2; ) {
      for (; e2.length > 3; ) e2.pop()();
      if (e2[1] < e2[0]) break;
      n2.i = e2 = e2[2];
    }
  };
  (B.prototype = new C$1()).__a = function(n2) {
    var t2 = this, e2 = j(t2.__v), r2 = t2.l.get(n2);
    return r2[0]++, function(u2) {
      var o2 = function() {
        t2.props.revealOrder ? (r2.push(u2), H(t2, n2, r2)) : u2();
      };
      e2 ? e2(o2) : o2();
    };
  }, B.prototype.render = function(n2) {
    this.i = null, this.l = /* @__PURE__ */ new Map();
    var t2 = F(n2.children);
    n2.revealOrder && "b" === n2.revealOrder[0] && t2.reverse();
    for (var e2 = t2.length; e2--; ) this.l.set(t2[e2], this.i = [1, 0, this.i]);
    return n2.children;
  }, B.prototype.componentDidUpdate = B.prototype.componentDidMount = function() {
    var n2 = this;
    this.l.forEach(function(t2, e2) {
      H(n2, e2, t2);
    });
  };
  var q = "undefined" != typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103, G = /^(?:accent|alignment|arabic|baseline|cap|clip(?!PathU)|color|dominant|fill|flood|font|glyph(?!R)|horiz|image(!S)|letter|lighting|marker(?!H|W|U)|overline|paint|pointer|shape|stop|strikethrough|stroke|text(?!L)|transform|underline|unicode|units|v|vector|vert|word|writing|x(?!C))[A-Z]/, J = /^on(Ani|Tra|Tou|BeforeInp|Compo)/, K = /[A-Z0-9]/g, Q = "undefined" != typeof document, X = function(n2) {
    return ("undefined" != typeof Symbol && "symbol" == typeof Symbol() ? /fil|che|rad/ : /fil|che|ra/).test(n2);
  };
  C$1.prototype.isReactComponent = true, ["componentWillMount", "componentWillReceiveProps", "componentWillUpdate"].forEach(function(t2) {
    Object.defineProperty(C$1.prototype, t2, { configurable: true, get: function() {
      return this["UNSAFE_" + t2];
    }, set: function(n2) {
      Object.defineProperty(this, t2, { configurable: true, writable: true, value: n2 });
    } });
  });
  var en = l$1.event;
  l$1.event = function(n2) {
    return en && (n2 = en(n2)), n2.persist = function() {
    }, n2.isPropagationStopped = function() {
      return this.cancelBubble;
    }, n2.isDefaultPrevented = function() {
      return this.defaultPrevented;
    }, n2.nativeEvent = n2;
  };
  var un = { configurable: true, get: function() {
    return this.class;
  } }, on = l$1.vnode;
  l$1.vnode = function(n2) {
    "string" == typeof n2.type && (function(n3) {
      var t2 = n3.props, e2 = n3.type, u2 = {}, o2 = -1 == e2.indexOf("-");
      for (var i2 in t2) {
        var l2 = t2[i2];
        if (!("value" === i2 && "defaultValue" in t2 && null == l2 || Q && "children" === i2 && "noscript" === e2 || "class" === i2 || "className" === i2)) {
          var c2 = i2.toLowerCase();
          "defaultValue" === i2 && "value" in t2 && null == t2.value ? i2 = "value" : "download" === i2 && true === l2 ? l2 = "" : "translate" === c2 && "no" === l2 ? l2 = false : "o" === c2[0] && "n" === c2[1] ? "ondoubleclick" === c2 ? i2 = "ondblclick" : "onchange" !== c2 || "input" !== e2 && "textarea" !== e2 || X(t2.type) ? "onfocus" === c2 ? i2 = "onfocusin" : "onblur" === c2 ? i2 = "onfocusout" : J.test(i2) && (i2 = c2) : c2 = i2 = "oninput" : o2 && G.test(i2) ? i2 = i2.replace(K, "-$&").toLowerCase() : null === l2 && (l2 = void 0), "oninput" === c2 && u2[i2 = c2] && (i2 = "oninputCapture"), u2[i2] = l2;
        }
      }
      "select" == e2 && (u2.multiple && Array.isArray(u2.value) && (u2.value = F(t2.children).forEach(function(n4) {
        n4.props.selected = -1 != u2.value.indexOf(n4.props.value);
      })), null != u2.defaultValue && (u2.value = F(t2.children).forEach(function(n4) {
        n4.props.selected = u2.multiple ? -1 != u2.defaultValue.indexOf(n4.props.value) : u2.defaultValue == n4.props.value;
      }))), t2.class && !t2.className ? (u2.class = t2.class, Object.defineProperty(u2, "className", un)) : t2.className && (u2.class = u2.className = t2.className), n3.props = u2;
    })(n2), n2.$$typeof = q, on && on(n2);
  };
  var ln = l$1.__r;
  l$1.__r = function(n2) {
    ln && ln(n2), n2.__c;
  };
  var cn = l$1.diffed;
  l$1.diffed = function(n2) {
    cn && cn(n2);
    var t2 = n2.props, e2 = n2.__e;
    null != e2 && "textarea" === n2.type && "value" in t2 && t2.value !== e2.value && (e2.value = null == t2.value ? "" : t2.value);
  };
  function DispenserItem({
    title = "Torus MAXI 68oz Water Dispenser",
    description = "68oz cordless water dispenser for daily home hydration.",
    priceOriginal = 49.95,
    priceCurrent = 39.96,
    colors = [
      { name: "Stone Grey", hex: "#9aa0a3" },
      { name: "Ocean Blue", hex: "#2d7fa3" },
      { name: "Fresh White", hex: "#f7f7f2" },
      { name: "Sage Green", hex: "#91a98b" }
    ],
    onAddAnother,
    onDetails,
    dispensetItems,
    cartData,
    setActiveCartData,
    bundleName
  }) {
    var _a, _b, _c;
    const [cartDatav2, setCartDatav2] = d(window.activeCartData || []);
    const [warning, setWarning] = d(false);
    const [activeDetailId, setActiveDetailId] = d(null);
    const [activeDetailTab, setActiveDetailTab] = d("description");
    const [cutsomWarning, setCustomWarning] = d(null);
    const [showBackUp, setShowBackup] = d({});
    const [removeProduct, setRemoveProduct] = d(false);
    const [selectedVariant, setSelectedVariant] = d(null);
    const [qtyMap, setQtyMap] = d({});
    const [colorIndexMap, setColorIndexMap] = d({});
    const [slotColorOverrides, setSlotColorOverrides] = d({});
    const handleConfirmQtyChange = (delta, minQty, currentQty, removeQty, variantid) => {
      if (minQty == 1 && currentQty == 1 && delta == -1) {
        setWarning(true);
        setTimeout(() => {
          setWarning(false);
        }, 3e3);
        return false;
      } else {
        if (minQty == 0 && currentQty == 1 && delta == -1) {
          setCustomWarning(variantid);
          if (removeQty && !!removeQty) {
            setCustomWarning(null);
            return true;
          } else {
            return false;
          }
        } else {
          return true;
        }
      }
    };
    const applyQtyDelta = (variantid, delta, minQty) => {
      const floor = minQty === 0 ? 0 : 1;
      const currentQty = qtyMap[variantid] ?? floor;
      const newQty = Math.max(floor, currentQty + delta);
      setQtyMap((prev) => ({ ...prev, [variantid]: newQty }));
    };
    const handleQtyChange = (delta, variantid, minQty, removeQty) => {
      const floor = minQty === 0 ? 0 : 1;
      const currentQty = qtyMap[variantid] ?? floor;
      const qtyConfirmation = handleConfirmQtyChange(delta, minQty, currentQty, removeQty, variantid);
      if (!qtyConfirmation) return null;
      applyQtyDelta(variantid, delta, minQty);
    };
    const incrementQty = (item, maxVariants) => {
      const currentQty = qtyMap[item.variantId] ?? 1;
      if (currentQty >= maxVariants) return;
      setQtyMap((prev) => ({ ...prev, [item.variantId]: currentQty + 1 }));
      const baseColorIndex = colorIndexMap[item.variantId] ?? 0;
      setSlotColorOverrides((prev) => ({
        ...prev,
        [item.variantId]: { ...prev[item.variantId] || {}, [currentQty]: baseColorIndex }
      }));
    };
    const handleAddAnother = (item, maxVariants) => {
      incrementQty(item, maxVariants);
    };
    const handleRemoveExtra = (item, slotIndex) => {
      setSlotColorOverrides((prev) => {
        const itemOverrides = prev[item.variantId] || {};
        const next = {};
        Object.entries(itemOverrides).forEach(([idxStr, colorIndex]) => {
          const idx = Number(idxStr);
          if (idx === slotIndex) return;
          next[idx > slotIndex ? idx - 1 : idx] = colorIndex;
        });
        return { ...prev, [item.variantId]: next };
      });
      setQtyMap((prev) => ({
        ...prev,
        [item.variantId]: Math.max(1, (prev[item.variantId] ?? 1) - 1)
      }));
    };
    const handleSlotColorChange = (item, slotIndex, colorIndex) => {
      if (slotIndex === 0) {
        setColorIndexMap((prev) => ({ ...prev, [item.variantId]: colorIndex }));
        return;
      }
      setSlotColorOverrides((prev) => ({
        ...prev,
        [item.variantId]: { ...prev[item.variantId] || {}, [slotIndex]: colorIndex }
      }));
    };
    const handleIncreaseQty = (item, maxVariants) => {
      const currentQty = qtyMap[item.variantId] ?? 1;
      if (currentQty === 0) {
        handleQtyChange(1, item.variantId, item.minQuantity);
        return;
      }
      incrementQty(item, maxVariants);
    };
    const handleDecreaseQty = (item) => {
      handleQtyChange(-1, item.variantId, item.minQuantity);
    };
    const handleRemoveWarningCard = (variantid, minQty) => {
      setRemoveProduct(true);
      setShowBackup((prev) => ({ ...prev, [variantid]: true }));
      setCustomWarning(null);
      handleQtyChange(-1, variantid, minQty, true);
    };
    const handleAddWarningCard = () => {
      setCustomWarning(null);
    };
    y(() => {
      var _a2, _b2;
      if (!((_b2 = (_a2 = dispensetItems == null ? void 0 : dispensetItems[0]) == null ? void 0 : _a2.items) == null ? void 0 : _b2.length)) return;
      setQtyMap((prev) => {
        const next = {};
        dispensetItems[0].items.forEach((item) => {
          next[item.variantId] = prev[item.variantId] ?? item.quantity ?? 1;
        });
        return next;
      });
      setColorIndexMap((prev) => {
        const next = {};
        dispensetItems[0].items.forEach((item) => {
          next[item.variantId] = prev[item.variantId] ?? 0;
        });
        return next;
      });
      setSlotColorOverrides((prev) => {
        const next = { ...prev };
        dispensetItems[0].items.forEach((item) => {
          const totalQty = item.quantity ?? 1;
          const itemOverrides = { ...next[item.variantId] || {} };
          for (let slotIdx = 1; slotIdx < totalQty; slotIdx++) {
            if (itemOverrides[slotIdx] === void 0) {
              itemOverrides[slotIdx] = 0;
            }
          }
          next[item.variantId] = itemOverrides;
        });
        return next;
      });
    }, [dispensetItems]);
    y(() => {
      var _a2, _b2;
      if (!((_b2 = (_a2 = dispensetItems == null ? void 0 : dispensetItems[0]) == null ? void 0 : _a2.items) == null ? void 0 : _b2.length)) return;
      const items = dispensetItems[0].items;
      const dispenserVariantIds = new Set(items.map((i2) => i2.variantId));
      setActiveCartData((prevCart) => {
        const cart = prevCart || [];
        const isOwnedByUs = (c2) => c2._dispenserGroup ? dispenserVariantIds.has(c2._dispenserGroup) : dispenserVariantIds.has(c2.variantId);
        const otherLines = cart.filter((c2) => !isOwnedByUs(c2));
        const currentDispenserLines = cart.filter(isOwnedByUs);
        const desiredDispenserLines = [];
        items.forEach((item) => {
          var _a3;
          const totalQty = qtyMap[item.variantId] ?? item.quantity ?? 1;
          const baseColorIndex = colorIndexMap[item.variantId] ?? 0;
          const overrides = slotColorOverrides[item.variantId] || {};
          const overriddenEntries = Object.entries(overrides).map(([slotIndex, colorIndex]) => [Number(slotIndex), colorIndex]).filter(([slotIndex]) => slotIndex > 0 && slotIndex < totalQty);
          const baseQty = totalQty - overriddenEntries.length;
          const rawLines = [];
          if (baseQty > 0) {
            const baseVariant = (_a3 = item.variants) == null ? void 0 : _a3[baseColorIndex];
            rawLines.push({
              ...item,
              variantId: (baseVariant == null ? void 0 : baseVariant.id) ?? item.variantId,
              quantity: baseQty,
              _uid: `${item.variantId}-slot-0`,
              _dispenserGroup: item.variantId,
              colorIndex: baseColorIndex
            });
          }
          overriddenEntries.forEach(([slotIndex, colorIndex]) => {
            var _a4;
            const variant = (_a4 = item.variants) == null ? void 0 : _a4[colorIndex];
            rawLines.push({
              ...item,
              variantId: (variant == null ? void 0 : variant.id) ?? item.variantId,
              quantity: 1,
              _uid: `${item.variantId}-slot-${slotIndex}`,
              _dispenserGroup: item.variantId,
              colorIndex
            });
          });
          const linesByVariant = /* @__PURE__ */ new Map();
          rawLines.forEach((line) => {
            const existing = linesByVariant.get(line.variantId);
            if (existing) {
              existing.quantity += line.quantity;
            } else {
              linesByVariant.set(line.variantId, { ...line });
            }
          });
          desiredDispenserLines.push(...linesByVariant.values());
        });
        const unchanged = currentDispenserLines.length === desiredDispenserLines.length && currentDispenserLines.every(
          (c2, i2) => c2.variantId === desiredDispenserLines[i2].variantId && c2.quantity === desiredDispenserLines[i2].quantity
        );
        if (unchanged) return cart;
        const updated = [...otherLines, ...desiredDispenserLines];
        window.activeCartData = [updated];
        return updated;
      });
    }, [qtyMap, colorIndexMap, slotColorOverrides, dispensetItems]);
    const getSwatchColor = (variantTitle) => {
      switch (variantTitle) {
        case "Shadow Pup":
          return "#5c5c5c";
        case "Blue Collar":
          return "#535d7e";
        case "Barkwood Beige":
          return "#d9d9d7";
        case "Red Rover":
          return "#bc333b";
        default:
          return "#5c5c5c";
      }
    };
    return /* @__PURE__ */ u$1("section", { className: "setup-group setup-group-dispensers", "aria-labelledby": "dispenser-heading", children: [
      /* @__PURE__ */ u$1("div", { className: "setup-group-head", children: [
        /* @__PURE__ */ u$1("div", { className: "group-title-row", children: [
          /* @__PURE__ */ u$1("h3", { id: "dispenser-heading", children: "STEP 1: Select Your Torus" }),
          /* @__PURE__ */ u$1("div", { className: "group-title-pills", children: /* @__PURE__ */ u$1("span", { className: "group-pill badge-blue", children: "Essential" }) })
        ] }),
        /* @__PURE__ */ u$1("p", { children: ((_a = dispensetItems[0]) == null ? void 0 : _a.description) || "This is the Torus water dispenser selected for your pet." })
      ] }),
      (_c = (_b = dispensetItems[0]) == null ? void 0 : _b.items) == null ? void 0 : _c.map((item) => {
        var _a2, _b2, _c2, _d, _e;
        const activeColorIndex = colorIndexMap[item.variantId] ?? 0;
        const totalSlots = qtyMap[item.variantId] ?? 1;
        const overrides = slotColorOverrides[item.variantId] || {};
        const maxVariants = ((_a2 = item.variants) == null ? void 0 : _a2.length) ?? 1;
        const canAddMore = totalSlots < maxVariants;
        const slotColorIndex = (slotIdx) => slotIdx === 0 ? activeColorIndex : overrides[slotIdx] ?? activeColorIndex;
        return /* @__PURE__ */ u$1("div", { className: "items", children: [
          /* @__PURE__ */ u$1("article", { className: "item", children: [
            /* @__PURE__ */ u$1("div", { className: "media-column", children: [
              /* @__PURE__ */ u$1("button", { className: "visual", type: "button", "aria-label": "View product media for Torus MAXI 68oz Water Dispenser", children: /* @__PURE__ */ u$1("div", { className: "symbol", "aria-hidden": "true", children: ((_b2 = item == null ? void 0 : item.image) == null ? void 0 : _b2.src) && /* @__PURE__ */ u$1(
                "img",
                {
                  src: item.image.src,
                  alt: item.title
                }
              ) }) }),
              /* @__PURE__ */ u$1("button", { className: "description-link", type: "button", onClick: () => {
                setActiveDetailId(item.variantId);
                setActiveDetailTab("description");
              }, children: "Product description" }),
              activeDetailId === item.variantId && /* @__PURE__ */ u$1("div", { className: "product_deatil_container", children: /* @__PURE__ */ u$1("div", { className: "product_deatil_wrapper", children: [
                /* @__PURE__ */ u$1("div", { className: "cancel_button", onClick: () => setActiveDetailId(null), children: /* @__PURE__ */ u$1("svg", { xmlns: "http://www.w3.org/2000/svg", width: "30px", height: "30px", viewBox: "0 0 24 24", role: "img", "aria-labelledby": "cancelIconTitle", stroke: "#000000", "stroke-width": "2", "stroke-linecap": "round", "stroke-linejoin": "round", fill: "none", color: "#000000", children: [
                  /* @__PURE__ */ u$1("title", { id: "cancelIconTitle", children: "Cancel" }),
                  /* @__PURE__ */ u$1("path", { d: "M15.5355339 15.5355339L8.46446609 8.46446609M15.5355339 8.46446609L8.46446609 15.5355339" }),
                  /* @__PURE__ */ u$1("path", { d: "M4.92893219,19.0710678 C1.02368927,15.1658249 1.02368927,8.83417511 4.92893219,4.92893219 C8.83417511,1.02368927 15.1658249,1.02368927 19.0710678,4.92893219 C22.9763107,8.83417511 22.9763107,15.1658249 19.0710678,19.0710678 C15.1658249,22.9763107 8.83417511,22.9763107 4.92893219,19.0710678 Z" })
                ] }) }),
                /* @__PURE__ */ u$1("div", { className: "product_image_container", children: ((_c2 = item == null ? void 0 : item.image) == null ? void 0 : _c2.src) && /* @__PURE__ */ u$1(
                  "img",
                  {
                    className: "product_image_drawer",
                    src: item.image.src,
                    alt: item.title
                  }
                ) }),
                /* @__PURE__ */ u$1("p", { className: "product_title", children: item.title }),
                /* @__PURE__ */ u$1("div", { className: "product_detail_tabs", role: "tablist", "aria-label": "Product information", children: ["Description", "Materials", "Technology"].map((tab) => {
                  const tabKey = tab.toLowerCase();
                  return /* @__PURE__ */ u$1(
                    "button",
                    {
                      type: "button",
                      role: "tab",
                      "aria-selected": activeDetailTab === tabKey,
                      className: `product_detail_tab${activeDetailTab === tabKey ? " active" : ""}`,
                      onClick: () => setActiveDetailTab(tabKey),
                      children: tab
                    },
                    tabKey
                  );
                }) }),
                /* @__PURE__ */ u$1("div", { className: "product_detail_tab_content", children: [
                  activeDetailTab === "description" && /* @__PURE__ */ u$1("div", { dangerouslySetInnerHTML: { __html: item.product_description } }),
                  activeDetailTab === "materials" && /* @__PURE__ */ u$1("div", { dangerouslySetInnerHTML: { __html: item.material } }),
                  activeDetailTab === "technology" && /* @__PURE__ */ u$1("div", { dangerouslySetInnerHTML: { __html: item.technology } })
                ] })
              ] }) })
            ] }),
            /* @__PURE__ */ u$1("div", { className: "item-body", children: [
              /* @__PURE__ */ u$1("h4", { children: item == null ? void 0 : item.title }),
              /* @__PURE__ */ u$1("div", { className: "why", children: /* @__PURE__ */ u$1("div", { dangerouslySetInnerHTML: { __html: item.short_description } }) }),
              cutsomWarning === item.variantId && item.minQuantity === 0 && /* @__PURE__ */ u$1("div", { className: "remove-card", children: [
                /* @__PURE__ */ u$1("h2", { className: "remove-card__title", children: [
                  "REMOVE ",
                  item == null ? void 0 : item.title,
                  "?"
                ] }),
                /* @__PURE__ */ u$1("p", { className: "remove-card__description", children: "Remove this only if it does not fit your pet routine." }),
                /* @__PURE__ */ u$1("div", { className: "remove-card__actions", children: [
                  /* @__PURE__ */ u$1("button", { className: "btn btn-primary", onClick: () => handleAddWarningCard(item.variantId), children: "Keep in setup" }),
                  /* @__PURE__ */ u$1("button", { className: "btn btn-secondary", onClick: () => handleRemoveWarningCard(item.variantId, item.minQuantity), children: "Yes, remove" })
                ] })
              ] }),
              showBackUp[item.variantId] && qtyMap[item.variantId] == 0 && /* @__PURE__ */ u$1("div", { className: "suggestion-card", children: [
                /* @__PURE__ */ u$1("h3", { className: "suggestion-card__title", children: "WHY WE SUGGESTED IT" }),
                /* @__PURE__ */ u$1("p", { className: "suggestion-card__description", children: "Included as the main water point for your pet's everyday home hydration." }),
                /* @__PURE__ */ u$1("button", { className: "suggestion-card__button", onClick: () => {
                  setRemoveProduct(false);
                  setCustomWarning(null);
                  setShowBackup((prev) => {
                    const next = { ...prev };
                    delete next[item.variantId];
                    return next;
                  });
                  handleQtyChange(1, item.variantId, item.minQuantity);
                }, children: "Add back to setup" })
              ] }),
              (qtyMap[item.variantId] ?? 1) > 0 && /* @__PURE__ */ u$1(S, { children: [
                /* @__PURE__ */ u$1("div", { className: "config-zone__wrapper", children: Array.from({ length: totalSlots }).map((_2, slotIdx) => {
                  var _a3, _b3, _c3;
                  const isBase = slotIdx === 0;
                  const currentColorIndex = slotColorIndex(slotIdx);
                  return /* @__PURE__ */ u$1("div", { className: `config-zone${isBase ? "" : " config-zone--extra"}`, children: /* @__PURE__ */ u$1("div", { className: "color-grid", children: [
                    /* @__PURE__ */ u$1("div", { children: [
                      /* @__PURE__ */ u$1(
                        "div",
                        {
                          className: "color-row-title",
                          style: isBase ? void 0 : { display: "flex", alignItems: "center", justifyContent: "space-between" },
                          children: [
                            /* @__PURE__ */ u$1("span", { children: [
                              "Dispenser ",
                              slotIdx + 1,
                              " — Choose color"
                            ] }),
                            !isBase && /* @__PURE__ */ u$1(
                              "button",
                              {
                                type: "button",
                                className: "config-zone__remove",
                                "aria-label": `Remove dispenser ${slotIdx + 1}`,
                                onClick: () => handleRemoveExtra(item, slotIdx),
                                style: { background: "none", border: "none", cursor: "pointer", padding: "0 0 0 8px" },
                                children: /* @__PURE__ */ u$1("svg", { xmlns: "http://www.w3.org/2000/svg", width: "18", height: "18", viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", "stroke-width": "2", "stroke-linecap": "round", "stroke-linejoin": "round", "aria-hidden": "true", children: [
                                  /* @__PURE__ */ u$1("path", { d: "M15.5355339 15.5355339L8.46446609 8.46446609M15.5355339 8.46446609L8.46446609 15.5355339" }),
                                  /* @__PURE__ */ u$1("path", { d: "M4.92893219,19.0710678 C1.02368927,15.1658249 1.02368927,8.83417511 4.92893219,4.92893219 C8.83417511,1.02368927 15.1658249,1.02368927 19.0710678,4.92893219 C22.9763107,8.83417511 22.9763107,15.1658249 19.0710678,19.0710678 C15.1658249,22.9763107 8.83417511,22.9763107 4.92893219,19.0710678 Z" })
                                ] })
                              }
                            )
                          ]
                        }
                      ),
                      /* @__PURE__ */ u$1("div", { className: "color-pills", role: "group", "aria-label": `Dispenser ${slotIdx + 1} color`, children: (_a3 = item.variants) == null ? void 0 : _a3.map((variant, index) => /* @__PURE__ */ u$1(
                        "button",
                        {
                          type: "button",
                          title: variant.title,
                          "aria-label": variant.title,
                          "aria-pressed": currentColorIndex === index,
                          className: `color-pill${currentColorIndex === index ? " active" : ""}`,
                          onClick: () => handleSlotColorChange(item, slotIdx, index),
                          children: /* @__PURE__ */ u$1(
                            "span",
                            {
                              className: "swatch",
                              style: { background: getSwatchColor(variant.title) },
                              "aria-hidden": "true"
                            }
                          )
                        },
                        variant.id
                      )) })
                    ] }),
                    !isBase && /* @__PURE__ */ u$1("div", { className: "mobile-color-queue", children: /* @__PURE__ */ u$1("span", { className: "queue-chip", children: [
                      /* @__PURE__ */ u$1(
                        "span",
                        {
                          className: "queue-dot",
                          style: { background: (_b3 = colors[currentColorIndex]) == null ? void 0 : _b3.hex },
                          "aria-hidden": "true"
                        }
                      ),
                      "Dispenser ",
                      slotIdx + 1,
                      ": ",
                      (_c3 = colors[currentColorIndex]) == null ? void 0 : _c3.name
                    ] }) })
                  ] }) }, `${item.variantId}-slot-${slotIdx}`);
                }) }),
                canAddMore && /* @__PURE__ */ u$1(
                  "button",
                  {
                    className: "add-dispenser",
                    type: "button",
                    onClick: () => handleAddAnother(item, maxVariants),
                    children: "+ Add another MAXI"
                  }
                )
              ] })
            ] }),
            /* @__PURE__ */ u$1("div", { className: "controls", children: /* @__PURE__ */ u$1("div", { className: "qty-price-row", children: [
              /* @__PURE__ */ u$1("div", { className: `qty-availibility`, children: [
                /* @__PURE__ */ u$1("div", { className: `qty${!item.available ? " disable" : ""}`, role: "group", "aria-label": "Quantity", children: [
                  /* @__PURE__ */ u$1("button", { type: "button", onClick: () => {
                    handleDecreaseQty(item);
                    setSelectedVariant(item.variantId);
                  }, "aria-label": "Decrease quantity", minQty: item.minQuantity, disabled: !item.available, children: "−" }),
                  /* @__PURE__ */ u$1("span", { "aria-live": "polite", children: qtyMap[item.variantId] ?? 1 }),
                  /* @__PURE__ */ u$1(
                    "button",
                    {
                      type: "button",
                      onClick: () => handleIncreaseQty(item, maxVariants),
                      "aria-label": "Increase quantity",
                      disabled: !item.available || (qtyMap[item.variantId] ?? 1) > 0 && !canAddMore,
                      children: "+"
                    }
                  )
                ] }),
                !item.available && /* @__PURE__ */ u$1("span", { className: "out-of-stock", children: "Out of Stock" })
              ] }),
              qtyMap[item.variantId] != 0 ? /* @__PURE__ */ u$1("div", { className: "price", children: [
                /* @__PURE__ */ u$1("span", { className: "price-original", children: [
                  /* @__PURE__ */ u$1("span", { className: "visually-hidden", children: "Original price " }),
                  /* @__PURE__ */ u$1("s", { children: [
                    "$",
                    (_d = item.price) == null ? void 0 : _d.toFixed(2)
                  ] })
                ] }),
                /* @__PURE__ */ u$1("span", { className: "price-current", children: [
                  /* @__PURE__ */ u$1("span", { className: "visually-hidden", children: "Hydration Kit price " }),
                  "$",
                  (_e = item.price * 0.9) == null ? void 0 : _e.toFixed(2)
                ] }),
                /* @__PURE__ */ u$1("span", { className: "price-offer", children: "Hydration Kit price" })
              ] }) : /* @__PURE__ */ u$1("div", { className: "removed_add_back", children: [
                /* @__PURE__ */ u$1("div", { className: "price-block", children: /* @__PURE__ */ u$1("p", { className: "price-removed", children: "Removed" }) }),
                /* @__PURE__ */ u$1("div", { className: "price-block", children: /* @__PURE__ */ u$1(
                  "p",
                  {
                    className: "price-add_back",
                    onClick: () => {
                      setRemoveProduct(false);
                      setCustomWarning(null);
                      setShowBackup((prev) => {
                        const next = { ...prev };
                        delete next[item.variantId];
                        return next;
                      });
                      handleQtyChange(1, item.variantId, item.minQuantity);
                    },
                    children: "Add Back"
                  }
                ) })
              ] })
            ] }) })
          ] }),
          warning && item.badgeVariant == "essential" && /* @__PURE__ */ u$1("div", { className: "essential_notes", children: /* @__PURE__ */ u$1("p", { children: [
            "This recommendation is based on your selected ",
            bundleName,
            " setup, but you're always free to customise your Hydration Kit."
          ] }) })
        ] }, item.variantId);
      })
    ] });
  }
  function IncludedStrip({ items }) {
    return /* @__PURE__ */ u$1("div", { className: "included-strip", children: [
      /* @__PURE__ */ u$1("div", { className: "included-strip-title", children: [
        /* @__PURE__ */ u$1("span", { className: "included-dot", "aria-hidden": "true" }),
        "Your recommended setup includes"
      ] }),
      /* @__PURE__ */ u$1("ul", { className: "included-grid", role: "list", children: items.map((item, index) => /* @__PURE__ */ u$1("li", { className: "included-card", children: [
        /* @__PURE__ */ u$1("strong", { children: item.title || item.label }),
        /* @__PURE__ */ u$1("span", { children: item.description || item.sublabel })
      ] }, item.title || item.label || index)) })
    ] });
  }
  function ResultActions({ onChangePetFit, onCustomize, onFiltersOnly, onReturnCached, showReturnButton }) {
    const [isCustomizeActive, setIsCustomizeActive] = d(false);
    console.log("isCustomizeActive ", isCustomizeActive);
    const handleChangePetFit = () => {
      setIsCustomizeActive(false);
      onChangePetFit("go-back");
    };
    const handleCustomize = (e2) => {
      setIsCustomizeActive(true);
      onCustomize == null ? void 0 : onCustomize(e2);
    };
    const handleFiltersOnly = () => {
      setIsCustomizeActive(false);
      onFiltersOnly("only-filter");
    };
    return /* @__PURE__ */ u$1("div", { className: "actions", role: "group", "aria-label": "Setup actions", children: [
      /* @__PURE__ */ u$1("button", { type: "button", className: "ghost", onClick: handleChangePetFit, children: "Change pet fit" }),
      /* @__PURE__ */ u$1("button", { type: "button", className: `ghost${isCustomizeActive ? " active" : ""}`, onClick: handleCustomize, children: "Customize instead" }),
      /* @__PURE__ */ u$1("button", { type: "button", className: "ghost", onClick: handleFiltersOnly, children: "I only need filters" }),
      showReturnButton && /* @__PURE__ */ u$1("button", { type: "button", className: "ghost", onClick: onReturnCached, children: "Return to previous setup" })
    ] });
  }
  function ResultHeader({ headline, subcopy }) {
    return /* @__PURE__ */ u$1("div", { className: "result-top", children: [
      /* @__PURE__ */ u$1("h2", { id: "resultHeadline", className: "result-headline", children: [
        headline,
        " Hydration Kit"
      ] }),
      /* @__PURE__ */ u$1("p", { id: "resultSubcopy", className: "result-subcopy", children: subcopy })
    ] });
  }
  function RecommendationPanel({
    headline = "Recommended for Everyday Hydration",
    subcopy = "A daily Torus setup that brings the dispenser, filters, and cleaning support together from the first order.",
    includedItems,
    onCustomize,
    onFiltersOnly,
    onReturnCached,
    selectedData,
    handleChangeFit,
    showReturnButton,
    handleReturnCached,
    handleCustomize
  }) {
    const defaultItems = [
      { title: "1 MAXI dispenser", description: "Home water access" },
      { title: "1 filter pack", description: "For home and walks" },
      { title: "Travel tote", description: "Carry dispenser essentials" },
      { title: "Cleaning kit", description: "Easier Torus upkeep" }
    ];
    return /* @__PURE__ */ u$1("div", { className: "result", children: [
      /* @__PURE__ */ u$1(ResultHeader, { headline: selectedData == null ? void 0 : selectedData.recommendedTitle, subcopy: selectedData == null ? void 0 : selectedData.recommendedDescription }),
      /* @__PURE__ */ u$1(IncludedStrip, { items: (includedItems == null ? void 0 : includedItems.length) ? includedItems : (selectedData == null ? void 0 : selectedData.summaryBar) || defaultItems }),
      /* @__PURE__ */ u$1(
        ResultActions,
        {
          onChangePetFit: handleChangeFit,
          onCustomize: handleCustomize,
          onFiltersOnly,
          onReturnCached: handleReturnCached,
          showReturnButton
        }
      )
    ] });
  }
  function SummaryCard({
    context = "Solo Dog",
    productTotal = 104.9,
    // bundleOffer = -20.98,
    bundleOffer = 0,
    setupTotal = 83.92,
    savingLabel = "Offer applied: 10% Hydration Kit saving",
    lineItems = [],
    completionCopy,
    onAddSetup,
    onSaveForLater,
    cartData,
    selectedData,
    bundleName,
    onSummaryBarChange,
    highlightAddSetup = false
  }) {
    var _a, _b, _c, _d;
    const [originalAmout, setOriginalAmount] = d(0);
    const [totalAmout, setTotalAmount] = d(0);
    const [totalDiscount, setTotalDiscount] = d(0);
    const [subscribeSavings, setSubscribeSavings] = d(0);
    const summaryZoneRef = A(null);
    const handleViewSummaryClick = () => {
      var _a2;
      (_a2 = summaryZoneRef.current) == null ? void 0 : _a2.scrollIntoView({ behavior: "smooth", block: "start" });
    };
    const filterItem = cartData == null ? void 0 : cartData.filter((item) => {
      var _a2;
      return (_a2 = item == null ? void 0 : item.name) == null ? void 0 : _a2.toLowerCase().includes("filter");
    });
    const activeItems = (cartData == null ? void 0 : cartData.filter((item) => (item == null ? void 0 : item.quantity) > 0)) || [];
    const isFilterOnlyCart = activeItems.length > 0 && activeItems.every((item) => {
      var _a2;
      return (_a2 = item == null ? void 0 : item.title) == null ? void 0 : _a2.toLowerCase().includes("filter");
    });
    const hasDispenser = bundleName === "order Replacement Filters" || isFilterOnlyCart || (cartData == null ? void 0 : cartData.some((item) => {
      var _a2;
      const titleLower = ((_a2 = item == null ? void 0 : item.title) == null ? void 0 : _a2.toLowerCase()) || "";
      return (item == null ? void 0 : item.quantity) > 0 && (titleLower.includes("mini") || titleLower.includes("maxi"));
    }));
    y(() => {
      var _a2, _b2, _c2;
      const total = cartData.reduce(
        (sum, item) => sum + (item == null ? void 0 : item.price) * item.quantity,
        0
      );
      cartData.reduce(
        (sum, item) => sum + (item == null ? void 0 : item.price) * 0.8 * item.quantity,
        0
      );
      const isFilterSubscribed = ((_a2 = filterItem == null ? void 0 : filterItem[0]) == null ? void 0 : _a2.plan) === "subscribe";
      const discount = cartData.reduce((sum, item) => {
        var _a3;
        const isFilter = (_a3 = item == null ? void 0 : item.name) == null ? void 0 : _a3.toLowerCase().includes("filter");
        if (isFilter) {
          if (isFilterSubscribed) return sum;
          return sum + (item == null ? void 0 : item.price) * 0.1 * item.quantity;
        }
        return sum + (item == null ? void 0 : item.price) * 0.1 * item.quantity;
      }, 0);
      cartData.reduce(
        (sum, item) => sum + ((item == null ? void 0 : item.plan) === "subscribe" ? item.price * 1 * item.quantity : 0),
        0
      );
      const isSubsc = isFilterSubscribed ? ((_b2 = filterItem == null ? void 0 : filterItem[0]) == null ? void 0 : _b2.price) * 0.2 * ((_c2 = filterItem == null ? void 0 : filterItem[0]) == null ? void 0 : _c2.quantity) : 0;
      setOriginalAmount(total);
      setTotalDiscount(discount);
      setSubscribeSavings(isSubsc);
      setTotalAmount(Number(total) - Number(discount) - Number(isSubsc));
    }, [cartData]);
    y(() => {
      if (!onSummaryBarChange) return;
      const groupedByNoun = {};
      const summaryBar = [];
      const summarybarDetails = selectedData == null ? void 0 : selectedData.summaryBar;
      const summarybarFilterDetails = (summarybarDetails == null ? void 0 : summarybarDetails.filter(
        (item) => {
          var _a2;
          return (_a2 = item == null ? void 0 : item.label) == null ? void 0 : _a2.toLowerCase().includes("filter");
        }
      )) || [];
      (cartData || []).filter((item) => item.quantity > 0).forEach((item) => {
        var _a2, _b2, _c2;
        const titleLower = ((_a2 = item.title) == null ? void 0 : _a2.toLowerCase()) || "";
        const isMini = titleLower.includes("mini");
        const isMaxi = titleLower.includes("maxi");
        const isFilter = (_b2 = item == null ? void 0 : item.name) == null ? void 0 : _b2.includes("filter");
        const isToteBag = titleLower.includes("tote");
        const isCleaningKit = titleLower.includes("cleaning kit");
        const isCap = titleLower.includes("cap");
        let noun = item.title;
        let description = item.description || "";
        if (isFilter) {
          noun = "filter pack";
          description = ((_c2 = summarybarFilterDetails == null ? void 0 : summarybarFilterDetails[0]) == null ? void 0 : _c2.sublabel) || description;
        } else if (isMini || isMaxi) {
          noun = `${isMini ? "MINI" : "MAXI"} dispenser`;
          description = "Home water access";
        } else if (isToteBag) {
          description = "Carry dispenser essentials";
        } else if (isCleaningKit) {
          description = "Easier Torus upkeep";
        } else if (isCap) {
          description = "Backup part ready";
        }
        if (!groupedByNoun[noun]) {
          const entry = { title: "", description: "" };
          groupedByNoun[noun] = { entry, noun, isFilter, description, qty: 0 };
          summaryBar.push(entry);
        }
        groupedByNoun[noun].qty += item.quantity;
      });
      Object.values(groupedByNoun).forEach(({ entry, noun, isFilter, description, qty }) => {
        var _a2;
        entry.title = `${qty} ${noun}${qty > 1 ? "s" : ""}`;
        entry.description = isFilter ? (summarybarFilterDetails == null ? void 0 : summarybarFilterDetails.length) > 0 ? (_a2 = summarybarFilterDetails[0]) == null ? void 0 : _a2.sublabel : description : description;
      });
      onSummaryBarChange(summaryBar);
    }, [cartData, onSummaryBarChange]);
    return /* @__PURE__ */ u$1("aside", { className: "summary", "aria-labelledby": "summary-heading", children: [
      /* @__PURE__ */ u$1("p", { className: "summary-context", id: "summary-heading", children: bundleName && bundleName }),
      /* @__PURE__ */ u$1("div", { className: "summary-zone", ref: summaryZoneRef, children: [
        /* @__PURE__ */ u$1("div", { className: "summary-pricing", children: [
          /* @__PURE__ */ u$1("div", { className: "row", children: [
            /* @__PURE__ */ u$1("span", { children: "Product total" }),
            /* @__PURE__ */ u$1("strong", { children: [
              "$",
              originalAmout && originalAmout.toFixed(2)
            ] })
          ] }),
          totalDiscount != 0 && /* @__PURE__ */ u$1("div", { className: "row", children: [
            /* @__PURE__ */ u$1("span", { children: "Hydration Kit offer" }),
            /* @__PURE__ */ u$1("strong", { children: [
              "-$",
              totalDiscount && totalDiscount.toFixed(2)
            ] })
          ] }),
          !!filterItem && ((_a = filterItem[0]) == null ? void 0 : _a.plan) == "subscribe" && /* @__PURE__ */ u$1("div", { className: "row", children: [
            /* @__PURE__ */ u$1("span", { children: "Subscribe savings" }),
            /* @__PURE__ */ u$1("strong", { children: [
              "-$",
              subscribeSavings.toFixed(2)
            ] })
          ] })
        ] }),
        /* @__PURE__ */ u$1("div", { className: "summary-total", children: [
          /* @__PURE__ */ u$1("span", { children: "Setup total" }),
          /* @__PURE__ */ u$1("strong", { children: [
            "$",
            totalAmout.toFixed(2)
          ] })
        ] }),
        /* @__PURE__ */ u$1("p", { className: "summary-saving", children: savingLabel })
      ] }),
      /* @__PURE__ */ u$1("div", { className: "summary-list", children: (cartData == null ? void 0 : cartData.length) > 0 && cartData.map((item) => {
        var _a2, _b2;
        if (!((item == null ? void 0 : item.quantity) > 0)) return null;
        const isFilter = (_a2 = item == null ? void 0 : item.name) == null ? void 0 : _a2.toLowerCase().includes("filter");
        const isFilterSubscribed = ((_b2 = filterItem == null ? void 0 : filterItem[0]) == null ? void 0 : _b2.plan) === "subscribe";
        const skipBundleDiscount = isFilterSubscribed && isFilter;
        const lineTotal = isFilter && skipBundleDiscount ? item.price * 0.8 * item.quantity : item.price * 0.9 * item.quantity;
        const lineFinalPrice = skipBundleDiscount ? lineTotal * 1 : lineTotal;
        return /* @__PURE__ */ u$1("div", { className: "row", children: [
          /* @__PURE__ */ u$1("span", { children: [
            item.title.toLowerCase().includes("advance filter") ? "Advance Filter" : item.title.toLowerCase().includes("standard filter") ? "Standard Filter" : item.title,
            item.title.toLowerCase().includes("filter") ? item.quantity > 1 ? " Packs" : " Pack" : "",
            " x ",
            item.quantity,
            isFilter ? /* @__PURE__ */ u$1("div", { children: /* @__PURE__ */ u$1("small", { className: "notes", children: item.plan ? item.plan === "onetime" ? "One Time Filter Purchase" : "Subscribe & Save 10%" : "One Time Filter Purchase" }) }) : /* @__PURE__ */ u$1("div", {})
          ] }),
          /* @__PURE__ */ u$1("div", { children: /* @__PURE__ */ u$1("strong", { children: [
            "$",
            lineFinalPrice.toFixed(2)
          ] }) })
        ] }, item._uid || item.variantId || item.productId);
      }) }),
      !!filterItem && ((_b = filterItem[0]) == null ? void 0 : _b.quantity) > 0 && /* @__PURE__ */ u$1("div", { className: "summary-zone", children: /* @__PURE__ */ u$1("div", { className: "summary-pricing_filter", children: [
        /* @__PURE__ */ u$1("div", { className: "row", children: [
          /* @__PURE__ */ u$1("span", { children: "Payment type" }),
          /* @__PURE__ */ u$1("strong", { children: !!filterItem && ((_c = filterItem[0]) == null ? void 0 : _c.plan) == "subscribe" ? "One-time setup + filter subscription" : "One-time purchase" })
        ] }),
        /* @__PURE__ */ u$1("div", { className: "row", children: [
          /* @__PURE__ */ u$1("span", { children: "Filter coverage" }),
          /* @__PURE__ */ u$1("strong", { children: !!filterItem && `${((_d = filterItem[0]) == null ? void 0 : _d.quantity) * 6} months` })
        ] })
      ] }) }),
      completionCopy && /* @__PURE__ */ u$1("p", { className: "completion-line", children: completionCopy }),
      !hasDispenser && /* @__PURE__ */ u$1("p", { className: "info-bar", children: "Add at least one Torus dispenser" }),
      /* @__PURE__ */ u$1("div", { className: "setup_button", children: /* @__PURE__ */ u$1(
        "button",
        {
          className: `primary${highlightAddSetup ? " highlight" : ""}`,
          type: "button",
          onClick: onAddSetup,
          disabled: !hasDispenser,
          children: [
            /* @__PURE__ */ u$1("span", { className: "add_setup", children: "Add my selection to cart" }),
            /* @__PURE__ */ u$1("div", { className: "spinner hide", children: /* @__PURE__ */ u$1("svg", { xmlns: "http://www.w3.org/2000/svg", width: "32", height: "32", viewBox: "0 0 24 24", children: [
              /* @__PURE__ */ u$1("path", { fill: "#fff", d: "M12,1A11,11,0,1,0,23,12,11,11,0,0,0,12,1Zm0,19a8,8,0,1,1,8-8A8,8,0,0,1,12,20Z", opacity: ".25" }),
              /* @__PURE__ */ u$1("path", { fill: "#fff", d: "M12,4a8,8,0,0,1,7.89,6.7A1.53,1.53,0,0,0,21.38,12h0a1.5,1.5,0,0,0,1.48-1.75,11,11,0,0,0-21.72,0A1.5,1.5,0,0,0,2.62,12h0a1.53,1.53,0,0,0,1.49-1.3A8,8,0,0,1,12,4Z", children: /* @__PURE__ */ u$1("animateTransform", { attributeName: "transform", dur: "0.75s", repeatCount: "indefinite", type: "rotate", values: "0 12 12;360 12 12" }) })
            ] }) })
          ]
        }
      ) }),
      /* @__PURE__ */ u$1("div", { className: "summary-mobile-bar", children: [
        /* @__PURE__ */ u$1("button", { type: "button", className: "mobile-view-summary", onClick: handleViewSummaryClick, children: "View summary" }),
        /* @__PURE__ */ u$1(
          "button",
          {
            type: "button",
            className: "mobile-add",
            onClick: onAddSetup,
            disabled: !hasDispenser,
            children: /* @__PURE__ */ u$1("span", { className: "mobile-add-prices", children: [
              /* @__PURE__ */ u$1("span", { className: "mobile_add_text", children: "ADD" }),
              originalAmout > totalAmout && /* @__PURE__ */ u$1("s", { className: "mobile-add-original", children: [
                "$",
                originalAmout.toFixed(2)
              ] }),
              /* @__PURE__ */ u$1("strong", { className: "mobile-add-total", children: [
                "$",
                totalAmout.toFixed(2)
              ] })
            ] })
          }
        )
      ] })
    ] });
  }
  function OptionGroup({ title, desc, options, selected, onSelect, hint }) {
    return /* @__PURE__ */ u$1("div", { className: "chooser-box", children: [
      /* @__PURE__ */ u$1("p", { className: "chooser-title", children: title }),
      /* @__PURE__ */ u$1(
        "div",
        {
          className: "chooser-options",
          role: "radiogroup",
          "aria-label": title,
          children: options.map((opt) => /* @__PURE__ */ u$1(
            "button",
            {
              role: "radio",
              "aria-checked": selected === opt.id,
              className: `option-btn${selected === opt.id ? " selected" : ""}`,
              onClick: () => onSelect(opt.id, opt),
              children: [
                /* @__PURE__ */ u$1("span", { className: "option-name", children: opt.name }),
                opt.price && /* @__PURE__ */ u$1("span", { className: "option-price", children: [
                  "$",
                  opt.price
                ] }),
                opt.badge && /* @__PURE__ */ u$1("span", { className: "sub-badge", "aria-label": `Save ${opt.badge}`, children: opt.badge })
              ]
            },
            opt.id
          ))
        }
      )
    ] });
  }
  function Filter({
    filterItems,
    setActiveCartData,
    cartData,
    showReturnButton,
    bundleName
  }) {
    var _a, _b, _c, _d, _e;
    const [filterQty, setFilterQty] = d(
      ((_c = (_b = (_a = filterItems == null ? void 0 : filterItems[0]) == null ? void 0 : _a.items) == null ? void 0 : _b[0]) == null ? void 0 : _c.quantity) ?? 1
    );
    const [filterType, setFilterType] = d("standard");
    const [currentFilter, setCurrentFilter] = d(filterItems);
    const [currentCheckFilterType, setCurrentCheckFilterType] = d();
    const [filterDelivery, setFilterDelivery] = d("onetime");
    const [cartDatav3, setCartDatav3] = d(window.activeCartData || []);
    const [returnBack, setReturnBack] = d(showReturnButton);
    const [warning, setWarning] = d(false);
    const [showProductDetail, setShowProductDetail] = d(false);
    const [activeDetailId, setActiveDetailId] = d(null);
    const [cutsomWarning, setCustomWarning] = d(null);
    const [showBackUp, setShowBackup] = d(false);
    const [removeProduct, setRemoveProduct] = d(false);
    const [removedVariantId, setRemovedVariantId] = d(null);
    const [activeDetailTab, setActiveDetailTab] = d("description");
    const filterPrice = filterType == "standard" ? 23.95 : 31.96;
    const filterOriginal = filterType == "standard" ? 29.95 : 39.95;
    const handleConfirmQtyChange = (delta, minQty, currentQty, removeQty, variantid) => {
      if (minQty == 1 && currentQty == 1 && delta == -1) {
        setWarning(true);
        setTimeout(() => {
          setWarning(false);
        }, 3e3);
        return false;
      } else {
        if (minQty == 0 && currentQty == 1 && delta == -1) {
          setCustomWarning(variantid);
          if (removeQty && !!removeQty) {
            setCustomWarning(null);
            return true;
          } else {
            return false;
          }
        } else {
          return true;
        }
      }
    };
    const handleChangeQty = (qty, variantid, minQty, removeQty) => {
      if (filterQty == 1 && minQty == 1) {
        setWarning(true);
        setTimeout(() => {
          setWarning(false);
        }, 3e3);
      }
      const qtyConfirmation = handleConfirmQtyChange(qty, minQty, filterQty, removeQty, variantid);
      if (!qtyConfirmation) return null;
      setFilterQty(filterQty + qty);
      const floor = minQty !== void 0 && minQty === 0 ? 0 : 1;
      const newQty = Math.max(floor, filterQty + qty);
      setFilterQty(newQty);
      const updated = cartData.map((cartItem) => {
        if (cartItem.variantId == variantid) {
          return { ...cartItem, quantity: newQty };
        }
        return cartItem;
      });
      window.activeCartData = [updated];
      setActiveCartData(updated);
      return [updated];
    };
    let filterOptions = ((_e = (_d = filterItems == null ? void 0 : filterItems[0]) == null ? void 0 : _d.items) == null ? void 0 : _e.map((item) => {
      var _a2, _b2, _c2, _d2;
      return {
        id: ((_a2 = item.title) == null ? void 0 : _a2.toLowerCase().includes("standard")) ? "standard" : "advanced",
        name: ((_b2 = item.title) == null ? void 0 : _b2.toLowerCase().includes("standard")) ? "Standard" : "Advanced",
        price: filterDelivery == "onetime" ? (_c2 = item.price * 0.9) == null ? void 0 : _c2.toFixed(2) : (_d2 = item.price * 0.8) == null ? void 0 : _d2.toFixed(2),
        variantid: item.variantId
      };
    })) || [];
    const handleSlectFilterType = (option) => {
      filterData(option);
    };
    const handlePurchaseType = (planname) => {
      const filterCart = cartData == null ? void 0 : cartData.filter((item) => {
        var _a2;
        return (_a2 = item == null ? void 0 : item.name) == null ? void 0 : _a2.toLowerCase().includes("filter");
      });
      const otherdata = cartData == null ? void 0 : cartData.filter((item) => {
        var _a2;
        return !((_a2 = item == null ? void 0 : item.name) == null ? void 0 : _a2.toLowerCase().includes("filter"));
      });
      filterCart[0].plan = planname;
      setActiveCartData([...filterCart, ...otherdata]);
    };
    const handleRemoveWarningCard = (variantid, minQty) => {
      setRemoveProduct(true);
      setShowBackup(true);
      setRemovedVariantId(variantid);
      setCustomWarning(null);
      handleChangeQty(-1, variantid, minQty, true);
    };
    const handleAddWarningCard = () => {
      setCustomWarning(null);
    };
    const filterData = q$1((option) => {
      var _a2, _b2, _c2, _d2;
      const selelectedFilter = (_b2 = (_a2 = currentFilter == null ? void 0 : currentFilter[0]) == null ? void 0 : _a2.items) == null ? void 0 : _b2.find(
        (item) => item.variantId == option.variantid
      );
      if (!selelectedFilter) return;
      const updatefilterData = {
        id: selelectedFilter.variantId,
        title: selelectedFilter.title,
        variantId: selelectedFilter.variantId,
        quantity: filterQty,
        plan: filterDelivery,
        plainID: ((_d2 = (_c2 = selelectedFilter == null ? void 0 : selelectedFilter.selling_plan_groups[0]) == null ? void 0 : _c2.selling_plans[0]) == null ? void 0 : _d2.id) || null,
        price: selelectedFilter.price,
        name: selelectedFilter.name
      };
      let datawithoutfilter = cartData.filter((item) => {
        var _a3;
        return !((_a3 = item.name) == null ? void 0 : _a3.toLowerCase().includes("filter"));
      });
      let allDatawithFilter = [...datawithoutfilter, updatefilterData];
      if (showReturnButton) {
        setActiveCartData([updatefilterData]);
      } else {
        setActiveCartData(allDatawithFilter);
      }
    }, [currentFilter, filterType, filterQty, filterDelivery, cartData, showReturnButton, filterItems]);
    y(() => {
      const currentOption = filterOptions.find((opt) => opt.id === filterType);
      if (currentOption) filterData(currentOption);
    }, [filterDelivery]);
    y(() => {
      setActiveCartData((prevCart) => {
        const updated = prevCart.map((cartItem) => {
          var _a2;
          if (!((_a2 = cartItem == null ? void 0 : cartItem.name) == null ? void 0 : _a2.toLowerCase().includes("filter"))) return cartItem;
          if (cartItem.quantity === filterQty) return cartItem;
          return { ...cartItem, quantity: filterQty };
        });
        const changed = updated.some((item, idx) => item !== prevCart[idx]);
        if (!changed) return prevCart;
        window.activeCartData = [updated];
        return updated;
      });
    }, [filterQty, filterItems]);
    return /* @__PURE__ */ u$1("section", { "aria-labelledby": "filter-coverage-title", className: "section-card", children: [
      /* @__PURE__ */ u$1("header", { className: "section-header", children: [
        /* @__PURE__ */ u$1("h2", { className: "section-title", id: "filter-coverage-title", children: "STEP 2: Select Your Filters" }),
        /* @__PURE__ */ u$1("div", { className: "badge-row", "aria-label": "Plan type: Essential, 6 months per pack", children: [
          filterItems[0].badgeVariant === "essential" && /* @__PURE__ */ u$1("span", { className: "badge badge-blue", children: "Essential" }),
          filterItems[0].badgeVariant === "optional" && /* @__PURE__ */ u$1("span", { className: "badge badge-yellow", children: "Optional" })
        ] })
      ] }),
      /* @__PURE__ */ u$1("p", { className: "section-subtitle", children: "Filters are included so your setup is ready to use from the first order." }),
      /* @__PURE__ */ u$1("p", { className: "section-matched", "aria-live": "polite", children: "Matched to your setup: 1 dispenser → 1 filter pack." }),
      filterItems.length > 0 && filterItems.map((item) => {
        var _a2, _b2;
        const standardFilterItem = item.items.find((subItem) => subItem.title.includes("Standard"));
        const advancedFilterItem = item.items.find((subItem) => subItem.title.includes("Advance"));
        const selectedFilterItem = filterType === "standard" ? standardFilterItem : advancedFilterItem;
        return /* @__PURE__ */ u$1("div", { className: "product-row", children: [
          /* @__PURE__ */ u$1("div", { className: "product-image-col", "aria-hidden": "true", children: [
            /* @__PURE__ */ u$1("div", { className: "product-img-box", children: selectedFilterItem && /* @__PURE__ */ u$1(
              "img",
              {
                src: (_a2 = selectedFilterItem.image) == null ? void 0 : _a2.src,
                alt: selectedFilterItem.title
              }
            ) }),
            /* @__PURE__ */ u$1("span", { className: "product-img-label", onClick: () => setActiveDetailId(item.variantId), children: "Product description" }),
            activeDetailId === item.variantId && /* @__PURE__ */ u$1("div", { className: "product_deatil_container", children: /* @__PURE__ */ u$1("div", { className: "product_deatil_wrapper", children: [
              /* @__PURE__ */ u$1("div", { className: "cancel_button", onClick: () => setActiveDetailId(null), children: /* @__PURE__ */ u$1("svg", { xmlns: "http://www.w3.org/2000/svg", width: "30px", height: "30px", viewBox: "0 0 24 24", role: "img", "aria-labelledby": "cancelIconTitle", stroke: "#000000", "stroke-width": "2", "stroke-linecap": "round", "stroke-linejoin": "round", fill: "none", color: "#000000", children: [
                " ",
                /* @__PURE__ */ u$1("title", { id: "cancelIconTitle", children: "Cancel" }),
                /* @__PURE__ */ u$1("path", { d: "M15.5355339 15.5355339L8.46446609 8.46446609M15.5355339 8.46446609L8.46446609 15.5355339" }),
                /* @__PURE__ */ u$1("path", { d: "M4.92893219,19.0710678 C1.02368927,15.1658249 1.02368927,8.83417511 4.92893219,4.92893219 C8.83417511,1.02368927 15.1658249,1.02368927 19.0710678,4.92893219 C22.9763107,8.83417511 22.9763107,15.1658249 19.0710678,19.0710678 C15.1658249,22.9763107 8.83417511,22.9763107 4.92893219,19.0710678 Z" })
              ] }) }),
              /* @__PURE__ */ u$1("div", { className: "product_image_container", children: selectedFilterItem && /* @__PURE__ */ u$1(
                "img",
                {
                  className: "product_image_drawer",
                  src: (_b2 = selectedFilterItem.image) == null ? void 0 : _b2.src,
                  alt: selectedFilterItem.title
                }
              ) }),
              filterType === "standard" ? /* @__PURE__ */ u$1("p", { className: "product_title", children: "Standard Filter" }) : /* @__PURE__ */ u$1("p", { className: "product_title", children: "Advanced Filter" }),
              /* @__PURE__ */ u$1("div", { className: "product_detail_tabs", role: "tablist", "aria-label": "Product information", children: ["Description", "Materials", "Technology"].map((tab) => {
                const tabKey = tab.toLowerCase();
                return /* @__PURE__ */ u$1(
                  "button",
                  {
                    type: "button",
                    role: "tab",
                    "aria-selected": activeDetailTab === tabKey,
                    className: `product_detail_tab${activeDetailTab === tabKey ? " active" : ""}`,
                    onClick: () => setActiveDetailTab(tabKey),
                    children: tab
                  },
                  tabKey
                );
              }) }),
              /* @__PURE__ */ u$1("div", { className: "product_detail_tab_content", children: [
                activeDetailTab === "description" && (filterType === "standard" ? /* @__PURE__ */ u$1("div", { dangerouslySetInnerHTML: { __html: filterItems[0].items[0].product_description } }) : /* @__PURE__ */ u$1("div", { dangerouslySetInnerHTML: { __html: filterItems[0].items[1].product_description } })),
                activeDetailTab === "materials" && (filterType === "standard" ? /* @__PURE__ */ u$1("div", { dangerouslySetInnerHTML: { __html: filterItems[0].items[0].material } }) : /* @__PURE__ */ u$1("div", { dangerouslySetInnerHTML: { __html: filterItems[0].items[1].material } })),
                activeDetailTab === "technology" && (filterType === "standard" ? /* @__PURE__ */ u$1("div", { dangerouslySetInnerHTML: { __html: filterItems[0].items[0].technology } }) : /* @__PURE__ */ u$1("div", { dangerouslySetInnerHTML: { __html: filterItems[0].items[1].technology } }))
              ] })
            ] }) })
          ] }),
          /* @__PURE__ */ u$1("div", { className: "product-content-col", children: [
            /* @__PURE__ */ u$1("div", { className: "badge-row", children: /* @__PURE__ */ u$1("span", { className: "badge badge-blue", children: "6 months per pack" }) }),
            /* @__PURE__ */ u$1("div", { className: "product-top", children: [
              /* @__PURE__ */ u$1("div", { className: "product-meta", children: [
                /* @__PURE__ */ u$1("h3", { className: "product-name", children: filterType === "standard" ? /* @__PURE__ */ u$1("p", { className: "product_title", children: "Standard Filter" }) : /* @__PURE__ */ u$1("p", { className: "product_title", children: "Advanced Filter" }) }),
                /* @__PURE__ */ u$1("div", { className: "product-desc", children: /* @__PURE__ */ u$1("div", { dangerouslySetInnerHTML: { __html: selectedFilterItem.short_description } }) })
              ] }),
              /* @__PURE__ */ u$1("div", { className: "price_remove_block", children: [
                /* @__PURE__ */ u$1("div", { className: "price-stepper", children: /* @__PURE__ */ u$1("div", { className: `stepper${!selectedFilterItem.available ? " disable" : ""}`, role: "group", "aria-label": `Quantity for Standard Filter Pack`, children: [
                  /* @__PURE__ */ u$1(
                    "button",
                    {
                      className: `stepper-btn`,
                      "aria-label": "Decrease quantity",
                      onClick: () => handleChangeQty(-1, selectedFilterItem.variantId, selectedFilterItem.minQuantity),
                      variantID: selectedFilterItem.variantId,
                      disabled: !selectedFilterItem.available,
                      children: "−"
                    }
                  ),
                  /* @__PURE__ */ u$1("span", { className: "stepper-count", "aria-live": "polite", "aria-atomic": "true", children: filterQty }),
                  /* @__PURE__ */ u$1(
                    "button",
                    {
                      className: `stepper-btn`,
                      "aria-label": "Increase quantity",
                      variantID: selectedFilterItem.variantId,
                      onClick: () => handleChangeQty(1, selectedFilterItem.variantId),
                      disabled: !selectedFilterItem.available,
                      children: "+"
                    }
                  )
                ] }) }),
                filterQty != 0 && /* @__PURE__ */ u$1("div", { className: "price-block", "aria-label": `Hydration Kit price $${filterPrice}, regular price $${filterOriginal}`, children: [
                  /* @__PURE__ */ u$1("span", { className: "price-original", "aria-label": "Original price", children: [
                    "$",
                    filterOriginal
                  ] }),
                  /* @__PURE__ */ u$1("div", { className: "price-current", children: [
                    "$",
                    filterDelivery == "onetime" ? (selectedFilterItem.price * 0.9).toFixed(2) : (selectedFilterItem.price * 0.8).toFixed(2)
                  ] }),
                  /* @__PURE__ */ u$1("div", { className: "price-label", children: "Hydration Kit price" })
                ] }),
                filterQty == 0 && /* @__PURE__ */ u$1("div", { className: "removed_add_back", children: [
                  /* @__PURE__ */ u$1("div", { className: "price-block", children: /* @__PURE__ */ u$1("p", { className: "price-removed", children: "Removed" }) }),
                  /* @__PURE__ */ u$1("div", { className: "price-block", children: /* @__PURE__ */ u$1(
                    "p",
                    {
                      className: "price-add_back",
                      onClick: () => {
                        setRemoveProduct(false);
                        setCustomWarning(null);
                        setShowBackup(false);
                        setRemovedVariantId(null);
                        handleChangeQty(1, item.items[0].variantId, item.items[0].minQuantity);
                      },
                      children: "Add Back"
                    }
                  ) })
                ] })
              ] })
            ] }),
            cutsomWarning === item.items[0].variantId && item.badgeVariant != "essential" && /* @__PURE__ */ u$1("div", { className: "remove-card", children: [
              /* @__PURE__ */ u$1("h2", { className: "remove-card__title", children: [
                "REMOVE ",
                item == null ? void 0 : item.title,
                "?"
              ] }),
              /* @__PURE__ */ u$1("p", { className: "remove-card__description", children: "Remove this only if it does not fit your pet routine." }),
              /* @__PURE__ */ u$1("div", { className: "remove-card__actions", children: [
                /* @__PURE__ */ u$1("button", { className: "btn btn-primary", onClick: () => handleAddWarningCard(item.items[0].variantId), children: "Keep in setup" }),
                /* @__PURE__ */ u$1("button", { className: "btn btn-secondary", onClick: () => handleRemoveWarningCard(item.items[0].variantId, item.items[0].minQuantity), children: "Yes, remove" })
              ] })
            ] }),
            !!filterQty && filterQty > 0 && /* @__PURE__ */ u$1(S, { children: [
              /* @__PURE__ */ u$1(
                OptionGroup,
                {
                  title: "Choose your filter type",
                  desc: "Standard works for most daily setups. Advanced gives stronger filtration.",
                  selected: filterType,
                  onSelect: (id, option) => {
                    setFilterType(id);
                    handleSlectFilterType(option);
                  },
                  options: filterOptions,
                  hint: filterType === "standard" ? "Standard selected: everyday carbon filtration for most Torus setups." : "Advanced selected: enhanced multi-stage filtration for Torus setups."
                }
              ),
              filterDelivery && /* @__PURE__ */ u$1(
                OptionGroup,
                {
                  title: "Choose how you want filters delivered",
                  desc: "Buy once, or subscribe to keep replacement filters arriving on schedule.",
                  selected: filterDelivery,
                  onSelect: (id) => {
                    setFilterDelivery(id);
                    handlePurchaseType(id);
                  },
                  options: [
                    { id: "onetime", name: "One-time" },
                    { id: "subscribe", name: "Subscribe & save", badge: "20%" }
                  ],
                  hint: filterDelivery === "onetime" ? "Buy once. Reorder when you're ready." : "Save 20% on every automatic refill delivery."
                }
              )
            ] }),
            showBackUp && item.badgeVariant == "optional" && removedVariantId == item.items[0].variantId && filterQty == 0 && /* @__PURE__ */ u$1("div", { className: "suggestion-card", children: [
              /* @__PURE__ */ u$1("h3", { className: "suggestion-card__title", children: "WHY WE SUGGESTED IT" }),
              /* @__PURE__ */ u$1("p", { className: "suggestion-card__description", children: "Included as the main water point for your pet's everyday home hydration." }),
              /* @__PURE__ */ u$1("button", { className: "suggestion-card__button", onClick: () => {
                setRemoveProduct(false);
                setCustomWarning(null);
                setShowBackup(false);
                setRemovedVariantId(null);
                handleChangeQty(1, item.items[0].variantId, item.items[0].minQuantity);
              }, children: "Add back to setup" })
            ] })
          ] })
        ] });
      }),
      warning && /* @__PURE__ */ u$1("div", { className: "essential_notes", children: /* @__PURE__ */ u$1("p", { children: [
        "This recommendation is based on your selected ",
        bundleName,
        " setup, but you're always free to customise your bundle."
      ] }) })
    ] });
  }
  function AddOn({ addOnItems, setActiveCartData, cartData, bundleID }) {
    var _a, _b;
    const [quantities, setQuantities] = d({});
    const [removedItems, setRemovedItems] = d({});
    const [activeDetailId, setActiveDetailId] = d(null);
    const [cutsomWarning, setCustomWarning] = d(null);
    const [showBackUp, setShowBackup] = d(null);
    const [removeProduct, setRemoveProduct] = d(false);
    const [selectedVariant, setSelectedVariant] = d(null);
    const [activeDetailTab, setActiveDetailTab] = d("description");
    const handleConfirmQtyChange = (delta, minQty, currentQty, removeQty, variantId) => {
      if (minQty == 1 && currentQty == 1 && delta == -1) {
        return false;
      } else {
        if (minQty == 0 && currentQty == 1 && delta == -1) {
          setCustomWarning(variantId);
          if (removeQty && !!removeQty) {
            setCustomWarning(null);
            return true;
          } else {
            return false;
          }
        } else {
          return true;
        }
      }
    };
    const handleChangeQty = (delta, variantId, minQty, removeQty) => {
      const item = cartData.find(
        (i2) => i2.variantId === variantId
      );
      if (!item) return;
      const currentQty = quantities[variantId] ?? item.quantity ?? item.minQuantity ?? 1;
      const qtyConfirmation = handleConfirmQtyChange(delta, minQty, currentQty, removeQty, variantId);
      if (!qtyConfirmation) {
        return null;
      }
      const minQuantity = item.minQuantity ?? 0;
      const maxQuantity = item.maxQuantity ?? Infinity;
      const newQty = Math.max(
        minQuantity,
        Math.min(maxQuantity, currentQty + delta)
      );
      setQuantities((prev) => ({
        ...prev,
        [variantId]: newQty
      }));
      const updatedCart = cartData.map(
        (i2) => i2.variantId === variantId ? { ...i2, quantity: newQty } : i2
      );
      window.activeCartData = [updatedCart];
      setActiveCartData(updatedCart);
    };
    const handleRemoveWarningCard = (variantId, minQty) => {
      setRemoveProduct(true);
      setShowBackup(variantId);
      setCustomWarning(null);
      handleChangeQty(-1, variantId, minQty, true);
    };
    const handleAddWarningCard = () => {
      setCustomWarning(null);
    };
    y(() => {
      var _a2;
      if (!((_a2 = addOnItems == null ? void 0 : addOnItems[0]) == null ? void 0 : _a2.items)) return;
      const isBuildYourOwn = bundleID === "build-your-own";
      setQuantities((prev) => {
        const updated = { ...prev };
        let changed = false;
        addOnItems[0].items.forEach((item) => {
          if (!(item.variantId in updated)) {
            updated[item.variantId] = isBuildYourOwn ? 0 : item.quantity ?? item.minQuantity ?? 1;
            changed = true;
          }
        });
        return changed ? updated : prev;
      });
      if (isBuildYourOwn) {
        const addOnVariantIds = new Set(addOnItems[0].items.map((i2) => i2.variantId));
        const zeroedCart = cartData.map(
          (i2) => addOnVariantIds.has(i2.variantId) ? { ...i2, quantity: 0 } : i2
        );
        window.activeCartData = [zeroedCart];
        setActiveCartData(zeroedCart);
      }
    }, [addOnItems, bundleID]);
    return /* @__PURE__ */ u$1("section", { "aria-labelledby": "addons-title", className: "section-card", children: [
      /* @__PURE__ */ u$1("header", { className: "section-header", children: [
        /* @__PURE__ */ u$1("h2", { className: "section-title", id: "addons-title", children: "STEP 3: Select Your Useful Add-Ons" }),
        /* @__PURE__ */ u$1("div", { className: "badge-row", children: /* @__PURE__ */ u$1("span", { className: "badge badge-gold", children: "Optional" }) })
      ] }),
      /* @__PURE__ */ u$1("p", { className: "section-subtitle", style: { marginBottom: "18px" }, children: "These extras help with cleaning, travel, or spare parts. Keep only what you need." }),
      (_b = (_a = addOnItems == null ? void 0 : addOnItems[0]) == null ? void 0 : _a.items) == null ? void 0 : _b.map((item) => {
        var _a2, _b2, _c, _d;
        if (removedItems[item.variantId]) return null;
        const qty = quantities[item.variantId] ?? (bundleID === "build-your-own" ? 0 : 1);
        return /* @__PURE__ */ u$1("div", { className: "product-row", style: { marginBottom: "12px" }, children: [
          /* @__PURE__ */ u$1("div", { className: "product-image-col", "aria-hidden": "true", children: [
            /* @__PURE__ */ u$1("div", { className: "product-img-box", children: ((_a2 = item == null ? void 0 : item.image) == null ? void 0 : _a2.src) && /* @__PURE__ */ u$1(
              "img",
              {
                className: "product-img",
                src: item.image.src,
                alt: item.title
              }
            ) }),
            /* @__PURE__ */ u$1("span", { className: "product-img-label", onClick: () => setActiveDetailId(item.variantId), children: "Product description" }),
            activeDetailId === item.variantId && /* @__PURE__ */ u$1("div", { className: "product_deatil_container", children: /* @__PURE__ */ u$1("div", { className: "product_deatil_wrapper", children: [
              /* @__PURE__ */ u$1("div", { className: "cancel_button", onClick: () => setActiveDetailId(null), children: /* @__PURE__ */ u$1("svg", { xmlns: "http://www.w3.org/2000/svg", width: "30px", height: "30px", viewBox: "0 0 24 24", role: "img", "aria-labelledby": "cancelIconTitle", stroke: "#000000", "stroke-width": "2", "stroke-linecap": "round", "stroke-linejoin": "round", fill: "none", color: "#000000", children: [
                /* @__PURE__ */ u$1("title", { id: "cancelIconTitle", children: "Cancel" }),
                /* @__PURE__ */ u$1("path", { d: "M15.5355339 15.5355339L8.46446609 8.46446609M15.5355339 8.46446609L8.46446609 15.5355339" }),
                /* @__PURE__ */ u$1("path", { d: "M4.92893219,19.0710678 C1.02368927,15.1658249 1.02368927,8.83417511 4.92893219,4.92893219 C8.83417511,1.02368927 15.1658249,1.02368927 19.0710678,4.92893219 C22.9763107,8.83417511 22.9763107,15.1658249 19.0710678,19.0710678 C15.1658249,22.9763107 8.83417511,22.9763107 4.92893219,19.0710678 Z" })
              ] }) }),
              /* @__PURE__ */ u$1("div", { className: "product_image_container", children: ((_b2 = item == null ? void 0 : item.image) == null ? void 0 : _b2.src) && /* @__PURE__ */ u$1(
                "img",
                {
                  className: "product_image_drawer",
                  src: item.image.src,
                  alt: item.title
                }
              ) }),
              /* @__PURE__ */ u$1("p", { className: "product_title", children: item.title }),
              /* @__PURE__ */ u$1("div", { className: "product_detail_tabs", role: "tablist", "aria-label": "Product information", children: ["Description", "Materials", "Technology"].map((tab) => {
                const tabKey = tab.toLowerCase();
                return /* @__PURE__ */ u$1(
                  "button",
                  {
                    type: "button",
                    role: "tab",
                    "aria-selected": activeDetailTab === tabKey,
                    className: `product_detail_tab${activeDetailTab === tabKey ? " active" : ""}`,
                    onClick: () => setActiveDetailTab(tabKey),
                    children: tab
                  },
                  tabKey
                );
              }) }),
              /* @__PURE__ */ u$1("div", { className: "product_detail_tab_content", children: [
                activeDetailTab === "description" && /* @__PURE__ */ u$1("div", { dangerouslySetInnerHTML: { __html: item.product_description } }),
                activeDetailTab === "materials" && /* @__PURE__ */ u$1("div", { dangerouslySetInnerHTML: { __html: item.material } }),
                activeDetailTab === "technology" && /* @__PURE__ */ u$1("div", { dangerouslySetInnerHTML: { __html: item.technology } })
              ] })
            ] }) })
          ] }),
          /* @__PURE__ */ u$1("div", { className: "product-content-col", children: [
            item.badge && /* @__PURE__ */ u$1("div", { className: "badge-row", children: /* @__PURE__ */ u$1("span", { className: "badge badge-gold", children: item.badge }) }),
            /* @__PURE__ */ u$1("div", { className: "product-top", children: [
              /* @__PURE__ */ u$1("div", { className: "product-meta", children: [
                /* @__PURE__ */ u$1("h3", { className: "product-name", children: item.title }),
                /* @__PURE__ */ u$1("div", { className: "product-desc", children: /* @__PURE__ */ u$1("div", { dangerouslySetInnerHTML: { __html: item.short_description } }) })
              ] }),
              /* @__PURE__ */ u$1("div", { className: "price_quantity_block", children: [
                /* @__PURE__ */ u$1("div", { className: "qty-availibility", children: [
                  /* @__PURE__ */ u$1(
                    "div",
                    {
                      className: `stepper${!item.available ? " disable" : ""}`,
                      role: "group",
                      "aria-label": `Quantity for ${item.title}`,
                      children: [
                        /* @__PURE__ */ u$1(
                          "button",
                          {
                            className: "stepper-btn",
                            "aria-label": "Decrease quantity",
                            onClick: () => {
                              handleChangeQty(-1, item.variantId, item.minQuantity);
                              setSelectedVariant(item.variantId);
                            },
                            disabled: qty <= item.minQuantity || !item.available,
                            children: "−"
                          }
                        ),
                        /* @__PURE__ */ u$1("span", { className: "stepper-count", "aria-live": "polite", "aria-atomic": "true", children: qty }),
                        /* @__PURE__ */ u$1(
                          "button",
                          {
                            className: "stepper-btn",
                            "aria-label": "Increase quantity",
                            onClick: () => handleChangeQty(1, item.variantId, item.minQuantity),
                            disabled: qty >= item.maxQuantity || !item.available,
                            children: "+"
                          }
                        )
                      ]
                    }
                  ),
                  !item.available && /* @__PURE__ */ u$1("span", { className: "out-of-stock", children: "Out of Stock" })
                ] }),
                qty != 0 && /* @__PURE__ */ u$1("div", { className: "price-block", children: [
                  /* @__PURE__ */ u$1("span", { className: "price-original", children: [
                    "$",
                    (_c = item.price) == null ? void 0 : _c.toFixed(2)
                  ] }),
                  /* @__PURE__ */ u$1("div", { className: "price-current", children: [
                    "$",
                    (_d = item.price * 0.9) == null ? void 0 : _d.toFixed(2)
                  ] }),
                  /* @__PURE__ */ u$1("div", { className: "price-label", children: "Hydration Kit price" })
                ] }),
                qty == 0 && /* @__PURE__ */ u$1("div", { className: "removed_add_back", children: [
                  /* @__PURE__ */ u$1("div", { className: "price-block", children: /* @__PURE__ */ u$1("p", { className: "price-removed", children: "Removed" }) }),
                  /* @__PURE__ */ u$1("div", { className: "price-block", children: /* @__PURE__ */ u$1(
                    "p",
                    {
                      className: "price-add_back",
                      onClick: () => {
                        setRemoveProduct(false);
                        setCustomWarning(null);
                        setShowBackup(null);
                        handleChangeQty(1, item.variantId, item.minQuantity);
                      },
                      children: "Add Back"
                    }
                  ) })
                ] })
              ] })
            ] }),
            /* @__PURE__ */ u$1("div", { className: "price-stepper", style: { justifyContent: "space-between" }, children: cutsomWarning !== item.variantId && showBackUp !== item.variantId && /* @__PURE__ */ u$1(
              "button",
              {
                className: "product-remove",
                onClick: () => handleChangeQty(-1, item.variantId, item.minQuantity),
                "aria-label": `Remove ${item.title} from bundle`,
                children: "Remove"
              }
            ) }),
            showBackUp === item.variantId && qty == 0 && /* @__PURE__ */ u$1("div", { className: "suggestion-card", children: [
              /* @__PURE__ */ u$1("h3", { className: "suggestion-card__title", children: "WHY WE SUGGESTED IT" }),
              /* @__PURE__ */ u$1("p", { className: "suggestion-card__description", children: "Included as the main water point for your pet's everyday home hydration." }),
              /* @__PURE__ */ u$1("button", { className: "suggestion-card__button", onClick: () => {
                setRemoveProduct(false);
                setCustomWarning(null);
                setShowBackup(null);
                handleChangeQty(1, item.variantId, item.minQuantity);
              }, children: "Add back to setup" })
            ] }),
            cutsomWarning === item.variantId && item.badgeVariant !== "essential" && /* @__PURE__ */ u$1("div", { className: "remove-card", children: [
              /* @__PURE__ */ u$1("h2", { className: "remove-card__title", children: [
                "REMOVE ",
                item.title,
                "?"
              ] }),
              /* @__PURE__ */ u$1("p", { className: "remove-card__description", children: "Remove this only if it does not fit your pet routine." }),
              /* @__PURE__ */ u$1("div", { className: "remove-card__actions", children: [
                /* @__PURE__ */ u$1("button", { className: "btn btn-primary", onClick: () => handleAddWarningCard(item.variantId), children: "Keep in setup" }),
                /* @__PURE__ */ u$1("button", { className: "btn btn-secondary", onClick: () => handleRemoveWarningCard(item.variantId, item.minQuantity), children: "Yes, remove" })
              ] })
            ] })
          ] })
        ] }, item.variantId);
      })
    ] });
  }
  function OptionalExtra({ extraProduct, setExtraProduct, setActiveCartData, cartData, setFiltereddata }) {
    var _a, _b;
    const [miniAdded, setMiniAdded] = d(false);
    const [capAdded, setCapAdded] = d(false);
    const [extraItems, setExtraItems] = d((_a = extraProduct[0]) == null ? void 0 : _a.items);
    y(() => {
      var _a2;
      setExtraItems((_a2 = extraProduct[0]) == null ? void 0 : _a2.items);
    }, [extraProduct]);
    const handleAddExtraItem = (varantid, item) => {
      if (item.title.toLowerCase().includes("mini")) {
        setFiltereddata((prev) => ({
          ...prev,
          sections: prev.sections.map(
            (section) => section.id == "dispenser" ? {
              ...section,
              items: [
                ...section.items,
                item
                // object to add
              ]
            } : section
          )
        }));
        const filterItems = extraItems.filter((item2) => item2.variantId != varantid);
        setExtraItems(filterItems);
        setActiveCartData(() => [
          ...cartData,
          item
        ]);
      } else {
        const filterItems = extraItems.filter((item2) => item2.variantId != varantid);
        const addItem = extraItems.filter((item2) => item2.variantId == varantid);
        addItem[0].quantity = 1;
        addItem[0].minQuantity = addItem[0].minQuantity ?? 0;
        addItem[0].maxQuantity = addItem[0].maxQuantity ?? 10;
        setFiltereddata((prev) => ({
          ...prev,
          sections: prev.sections.map(
            (section) => section.id == "useful-add-ons" ? {
              ...section,
              items: [
                ...section.items,
                addItem[0]
              ]
            } : section
          )
        }));
        const newCartData = [...cartData, addItem[0]];
        setExtraItems(filterItems);
        setActiveCartData(newCartData);
      }
    };
    return /* @__PURE__ */ u$1(S, { children: !!extraProduct && !!extraProduct[0] && ((_b = extraProduct[0]) == null ? void 0 : _b.items.length) > 0 && /* @__PURE__ */ u$1("section", { "aria-labelledby": "optional-extras-title", className: "section-card", children: [
      /* @__PURE__ */ u$1("header", { className: "section-header", style: { marginBottom: "16px" }, children: /* @__PURE__ */ u$1("h2", { className: "section-title", id: "optional-extras-title", children: "Optional extras" }) }),
      /* @__PURE__ */ u$1("p", { className: "section-subtitle", style: { marginBottom: "16px" }, children: "Not required for your setup. Add only if it fits how you use Torus." }),
      /* @__PURE__ */ u$1("div", { className: "extras-grid", children: !!extraItems && extraItems.length > 0 && extraItems.map((item) => {
        var _a2, _b2, _c;
        return /* @__PURE__ */ u$1("article", { className: "extra-card", "aria-label": "Add a MINI dispenser", children: [
          /* @__PURE__ */ u$1("div", { className: "extra-img-box", "aria-hidden": "true", children: ((_a2 = item == null ? void 0 : item.image) == null ? void 0 : _a2.src) && /* @__PURE__ */ u$1(
            "img",
            {
              className: "extra-img",
              src: item.image.src,
              alt: item.title
            }
          ) }),
          /* @__PURE__ */ u$1("h3", { className: "extra-name", children: item.title }),
          /* @__PURE__ */ u$1("p", { className: "extra-desc", children: ((_b2 = extraProduct[0]) == null ? void 0 : _b2.description) && ((_c = extraProduct[0]) == null ? void 0 : _c.description) }),
          /* @__PURE__ */ u$1(
            "button",
            {
              className: `add-btn${!item.available ? " disable" : ""}`,
              "aria-label": item.title,
              "aria-pressed": item.title,
              onClick: () => {
                setMiniAdded((v2) => !v2);
                handleAddExtraItem(item.variantId, item);
              },
              disabled: !item.available,
              children: "Add if useful"
            }
          ),
          !item.available && /* @__PURE__ */ u$1("span", { className: "out-of-stock", children: "Out of Stock" })
        ] });
      }) })
    ] }) });
  }
  function TorusRecommendation({
    selectedData,
    cartData,
    setActiveCartData,
    extraProduct,
    setExtraProduct,
    handleChangeFit,
    handleFiltersOnly,
    showReturnButton,
    handleReturnCached,
    handleCustomize,
    setFiltereddata,
    activeSetUpData,
    bundleName,
    bundleID,
    bundleImage,
    filterResetKey
  }) {
    var _a;
    const [summaryBarItems, setSummaryBarItems] = d([]);
    const [isCheckingOut, setIsCheckingOut] = d(false);
    const [isBundleSelected, setIsBundleSelected] = d(false);
    const handleSummaryBarChange = q$1((items) => {
      setSummaryBarItems(items);
    }, []);
    console.log("summaryBarItems ", summaryBarItems);
    const lineItems = [
      { label: "Torus MAXI 68oz Water Dispenser × 1", value: "$39.96" },
      {
        label: "Standard Filter Pack — 6 Filters × 1",
        note: "One-time filter purchase",
        value: "$19.96"
      },
      { label: "Torus Cleaning Kit × 1", value: "$9.60" },
      { label: "Torus Travel Tote × 1", value: "$14.40" },
      { label: "Payment type", value: "One-time purchase" },
      { label: "Filter coverage", value: "6 months" }
    ];
    const optionBundleImage = "https://cdn.shopify.com/s/files/1/2275/7427/files/Dog_and_Cat_in_Snow_1.png?v=1781253705";
    const sections = selectedData == null ? void 0 : selectedData.sections;
    const dispensetItems = T$1(
      () => sections == null ? void 0 : sections.filter((item) => item.title == "Your dispenser"),
      [sections]
    );
    const filterItems = T$1(
      () => sections == null ? void 0 : sections.filter((item) => item.title == "Filter coverage"),
      [sections]
    );
    const addOnItems = T$1(
      () => sections == null ? void 0 : sections.filter((item) => item.title == "Useful add-ons"),
      [sections]
    );
    const optionalExtraItems = T$1(
      () => sections == null ? void 0 : sections.filter((item) => item.title == "Optional extras"),
      [sections]
    );
    const cartfilterData = cartData == null ? void 0 : cartData.filter((item) => {
      var _a2;
      return (_a2 = item == null ? void 0 : item.title) == null ? void 0 : _a2.toLowerCase().includes("filter");
    });
    !!cartfilterData && ((_a = cartfilterData[0]) == null ? void 0 : _a.plan);
    const handleAddToCart = async (showSpinner = true) => {
      const uniqueBundleId = `${bundleID}-${(/* @__PURE__ */ new Date()).toISOString()}`;
      try {
        const items = cartData.length > 0 && cartData.map((item) => ({
          id: item.variantId,
          quantity: item.quantity,
          selling_plan: item.plan == "subscribe" ? Number(item.plainID) : null,
          properties: {
            _bundleId: uniqueBundleId,
            _bundleTitle: bundleName,
            _bundleImage: bundleImage || optionBundleImage,
            // '_bundle-subscription': productPlan == 'subscribe' ? true : false,
            "_hydration-kit": item.plan == "subscribe" ? false : true
          }
        }));
        const spinner = document.querySelector(".summary .primary .spinner");
        const buttonPrimary = document.querySelector(".summary .primary .add_setup");
        if (showSpinner) {
          spinner.classList.remove("hide");
          buttonPrimary.classList.add("hide");
        }
        const addResponse = await fetch("/cart/add.js", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json"
          },
          body: JSON.stringify({ items })
        });
        if (!addResponse.ok) {
          const err = await addResponse.json();
          throw new Error(err.description || "Failed to add items to cart");
        }
        if (showSpinner) {
          spinner.classList.add("hide");
          buttonPrimary.classList.remove("hide");
        }
        const sectionsRes = await fetch("/cart?sections=cart-drawer,cart-icon-bubble");
        const sections2 = await sectionsRes.json();
        const parser = new DOMParser();
        const newDoc = parser.parseFromString(sections2["cart-drawer"], "text/html");
        const newCartDrawer = newDoc.querySelector("cart-drawer");
        const liveCartDrawer = document.querySelector("cart-drawer");
        if (liveCartDrawer && newCartDrawer) {
          liveCartDrawer.innerHTML = newCartDrawer.innerHTML;
        }
        const iconWrapper = document.querySelector("#shopify-section-cart-icon-bubble");
        if (iconWrapper && sections2["cart-icon-bubble"]) {
          const iconDoc = parser.parseFromString(sections2["cart-icon-bubble"], "text/html");
          const newIcon = iconDoc.querySelector("#shopify-section-cart-icon-bubble");
          if (newIcon) iconWrapper.innerHTML = newIcon.innerHTML;
        }
        const liveBubble = document.querySelector(".cart-count-bubble");
        if (liveBubble) {
          liveBubble.classList.remove("hide");
        } else {
          const cartLink = document.querySelector('a[href="/cart"]');
          if (cartLink) {
            const totalQty = items.reduce((sum, item) => sum + item.quantity, 0);
            const bubble = document.createElement("div");
            bubble.className = "cart-count-bubble";
            bubble.innerHTML = `<span aria-hidden="true">${totalQty}</span>`;
            cartLink.appendChild(bubble);
          }
        }
        document.dispatchEvent(new CustomEvent("cart:updated", { bubbles: true }));
        if (liveCartDrawer) {
          if (typeof liveCartDrawer.open === "function") {
            liveCartDrawer.open();
          } else {
            liveCartDrawer.classList.add("active");
          }
          let cartHeader = document.querySelector(".drawer__inner .drawer__header");
          if (cartHeader) {
            cartHeader.style.setProperty("display", "flex", "important");
            cartHeader.style.setProperty("width", "100%", "important");
          }
        }
        return true;
      } catch (error) {
        console.error("Add to cart error:", error);
        return false;
      }
    };
    return /* @__PURE__ */ u$1("main", { className: "torus-rec-page", children: [
      /* @__PURE__ */ u$1("section", { className: "rec", "aria-label": "Recommended setup", children: [
        /* @__PURE__ */ u$1(RecommendationPanel, { selectedData, includedItems: summaryBarItems, handleChangeFit, onFiltersOnly: handleFiltersOnly, showReturnButton, handleReturnCached, handleCustomize }),
        /* @__PURE__ */ u$1("div", { className: "label", children: [
          /* @__PURE__ */ u$1("h2", { id: "itemsTitle", children: "Now Make Your Selections" }),
          /* @__PURE__ */ u$1("span", { children: "Each item includes why it belongs in this setup." })
        ] }),
        !!dispensetItems && (dispensetItems == null ? void 0 : dispensetItems.length) > 0 && /* @__PURE__ */ u$1("div", { id: "itemsList", children: /* @__PURE__ */ u$1(DispenserItem, { dispensetItems, setActiveCartData, cartData, bundleID, bundleName }) }),
        !!filterItems && (filterItems == null ? void 0 : filterItems.length) > 0 && /* @__PURE__ */ u$1("div", { children: /* @__PURE__ */ u$1(Filter, { filterItems, setActiveCartData, cartData, showReturnButton, bundleID, bundleName }, filterResetKey) }),
        !!addOnItems && (addOnItems == null ? void 0 : addOnItems.length) > 0 && /* @__PURE__ */ u$1("div", { children: /* @__PURE__ */ u$1(AddOn, { addOnItems, setActiveCartData, cartData, bundleID }) }),
        !!addOnItems && (addOnItems == null ? void 0 : addOnItems.length) > 0 && /* @__PURE__ */ u$1("div", { children: /* @__PURE__ */ u$1(
          OptionalExtra,
          {
            optionalExtraItems,
            extraProduct,
            setExtraProduct,
            setActiveCartData,
            cartData,
            setFiltereddata
          }
        ) })
      ] }),
      !!cartData && cartData.length > 0 && /* @__PURE__ */ u$1(
        SummaryCard,
        {
          lineItems,
          cartData,
          selectedData,
          onAddSetup: handleAddToCart,
          completionCopy: "Your hydration setup, your way — choose the dispenser, filters, and extras that fit.",
          bundleName,
          onSummaryBarChange: handleSummaryBarChange,
          highlightAddSetup: isBundleSelected
        }
      )
    ] });
  }
  function TorusLoader() {
    return /* @__PURE__ */ u$1("div", { className: "torus-loader-overlay", children: /* @__PURE__ */ u$1(
      "svg",
      {
        className: "torus-loader-logo",
        viewBox: "0 0 100 100",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
          /* @__PURE__ */ u$1(
            "circle",
            {
              className: "torus-loader-track",
              cx: "50",
              cy: "50",
              r: "42",
              fill: "none",
              strokeWidth: "8"
            }
          ),
          /* @__PURE__ */ u$1(
            "circle",
            {
              className: "torus-loader-arc",
              cx: "50",
              cy: "50",
              r: "42",
              fill: "none",
              strokeWidth: "8",
              strokeLinecap: "round"
            }
          )
        ]
      }
    ) });
  }
  function TorusBundleLanding({ bundleAllData, onSelect }) {
    const [active, setActive] = d(false);
    const [activeSetUpData, setActiveSetUpData] = d(window.activeSetUp || []);
    const [filteredData, setFiltereddata] = d(window.activeSetUp || []);
    const [activeCartData, setActiveCartData] = d([]);
    const [currentproducList, setcurrentproducList] = d([]);
    const [extraProduct, setExtraProduct] = d([]);
    const [showReturnButton, setShowReturnButton] = d(false);
    const [bundleTitle, setyBundleTitle] = d("");
    const [bundleID, setyBundleID] = d(null);
    const [bundleImage, setBundleImage] = d("");
    const [filterResetKey, setFilterResetKey] = d(0);
    const [transitioning, setTransitioning] = d(false);
    const [initialLoading, setInitialLoading] = d(true);
    const transitionTimeoutRef = A(null);
    const initialSetUpDataRef = A(null);
    const dataReady = !!(bundleAllData == null ? void 0 : bundleAllData.bundleBuilder);
    const params = new URLSearchParams(window.location.search);
    y(() => {
      const timer = setTimeout(() => setInitialLoading(false), 1e3);
      return () => clearTimeout(timer);
    }, []);
    y(() => {
      var _a;
      if (!dataReady) return;
      const type = params.get("type");
      if (!type) return;
      const matchedData = (_a = bundleAllData.bundleBuilder.setups) == null ? void 0 : _a[type];
      if (matchedData) {
        window.activeSetUp = matchedData;
        initialSetUpDataRef.current = matchedData;
        handleSelectedOption(matchedData);
      }
    }, [dataReady]);
    let activeSetUp = window.activeSetUp;
    const handleSelectedOption = (option, skipTransition = false) => {
      console.log("option ", option);
      if (!option) return;
      if (!skipTransition) {
        setTransitioning(true);
      }
      clearTimeout(transitionTimeoutRef.current);
      setyBundleTitle(option.recommendedTitle);
      setyBundleID(option.id);
      setBundleImage(option.bundleImage);
      setActiveSetUpData(option);
      setFiltereddata(option);
      setActive(true);
      let cartDetailedData = option.sections.filter((item) => item.title !== "Optional extras");
      let extraProductData = option.sections.filter((item) => item.title == "Optional extras");
      window.extraProductData = extraProductData;
      setExtraProduct(extraProductData);
      let cartData = !!cartDetailedData && cartDetailedData.length > 0 && cartDetailedData.map((item) => item.items);
      if (!!cartData && cartData.length > 0) {
        setActiveCartData(cartData.flat().filter(((item) => {
          var _a;
          return !((_a = item.title) == null ? void 0 : _a.toLowerCase().includes("advance")) && item.available;
        })));
        window.activeCartData = [cartData.flat()];
      }
      if (!skipTransition) {
        transitionTimeoutRef.current = setTimeout(() => setTransitioning(false), 400);
      }
    };
    const handleInitialSelect = (option) => {
      initialSetUpDataRef.current = option;
      handleSelectedOption(option);
    };
    const handleExtraProduct = (item) => {
      const usefulAddons = activeSetUp.sections.find(
        (section) => section.id === "useful-addons"
      );
      if (usefulAddons) {
        usefulAddons.items.push(item);
      }
    };
    const handleChangePetFIt = (val) => {
      const url = new URL(window.location.href);
      url.searchParams.delete("type");
      window.history.replaceState({}, "", url);
      if (typeof window.torusGoToKits === "function") {
        window.torusGoToKits();
      } else {
        window.location.href = "/#kits";
      }
    };
    const handleFilterSection = (val) => {
      var _a, _b;
      if (val == "only-filter") {
        const initialData = initialSetUpDataRef.current || activeSetUpData;
        setActiveSetUpData(initialData);
        setFiltereddata({
          ...initialData,
          sections: initialData.sections.filter(
            (item) => item.id === "filter-coverage"
          )
        });
        const filterData = (_b = (_a = bundleAllData == null ? void 0 : bundleAllData.bundleBuilder) == null ? void 0 : _a.setups) == null ? void 0 : _b["replacement-filters"];
        const filterSectionItems = filterData.sections[0].items;
        const defaultFilterItem = filterSectionItems.find((item) => item.defaultFilterTypeId === "standard") || filterSectionItems[0];
        setActiveCartData(() => [defaultFilterItem]);
      }
      setShowReturnButton(true);
    };
    const handleCached = () => {
      const initialData = initialSetUpDataRef.current || activeSetUpData;
      setShowReturnButton(false);
      setFiltereddata(initialData);
      handleSelectedOption(initialData);
    };
    const handleCustom = () => {
      console.log("mhgh", activeSetUpData.customizeFlow);
      if (!(activeSetUpData == null ? void 0 : activeSetUpData.customizeFlow)) return;
      handleSelectedOption(activeSetUpData.customizeFlow, true);
      setFilterResetKey((prev) => prev + 1);
    };
    const recommendationReady = active && !transitioning && window.activeCartData && activeCartData && filteredData;
    const showLoader = initialLoading || !dataReady || transitioning || active && !recommendationReady;
    return /* @__PURE__ */ u$1("main", { children: [
      !active && !initialLoading && dataReady && /* @__PURE__ */ u$1("div", { children: [
        /* @__PURE__ */ u$1(TorusBundleHero, {}),
        /* @__PURE__ */ u$1(TorusPetSelector, { data: bundleAllData, onSelect, handleSelectedOption: handleInitialSelect })
      ] }),
      recommendationReady && /* @__PURE__ */ u$1("div", { children: /* @__PURE__ */ u$1(
        TorusRecommendation,
        {
          selectedData: filteredData,
          bundleName: bundleTitle,
          bundleID,
          bundleImage,
          cartData: activeCartData,
          setActiveCartData,
          extraProduct,
          setExtraProduct: handleExtraProduct,
          handleChangeFit: handleChangePetFIt,
          handleFiltersOnly: handleFilterSection,
          showReturnButton,
          handleReturnCached: handleCached,
          handleCustomize: handleCustom,
          setFiltereddata,
          activeSetUpData,
          filterResetKey
        }
      ) }),
      showLoader && /* @__PURE__ */ u$1(TorusLoader, {})
    ] });
  }
  console.log("hhh", window.quizListingData);
  let bundleAllDatas = {
    bundleBuilder: window.quizListingData
  };
  function BundleApp({ bundleAllData, products }) {
    const [selectedItems, setSelectedItems] = d([]);
    return /* @__PURE__ */ u$1("div", { class: "bundle-app", children: [
      /* @__PURE__ */ u$1("div", { class: "product-grid" }),
      /* @__PURE__ */ u$1(TorusBundleLanding, { bundleAllData: bundleAllDatas })
    ] });
  }
  document.addEventListener("DOMContentLoaded", () => {
    const mountPoint = document.getElementById("preact-bundle-root");
    if (mountPoint) {
      const productData = JSON.parse(
        mountPoint.dataset.products || "[]"
      );
      R(/* @__PURE__ */ u$1(BundleApp, { products: productData, bundleAllData: window.bundleAllData }), mountPoint);
    }
  });
})();
